"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconLookupService = void 0;
var rxjs_1 = require("rxjs");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
function L(id, value) {
    return {
        id: id,
        value: value
    };
}
var FalconLookupService = exports.FalconLookupService = /** @class */ (function () {
    function FalconLookupService() {
        this.lookups = {
            polarAnswer: [
                L("true", "Yes"),
                L("false", "No")
            ],
            polarAnswerReverseValues: [
                L("false", "Yes"),
                L("true", "No")
            ],
            polarAnswerReverse: [
                L("false", "No"),
                L("true", "Yes")
            ],
            occupation: [
                L("1", "Abattoir Worker	"),
                L("01A", "Abbot"),
                L("02A", "Abstractor"),
                L("391", "Accommodation Officer"),
                L("03A", "Accompanist"),
                L("53D", "Account Director"),
                L("D77", "Account Executive"),
                L("D78", "Account Manager"),
                L("A01", "Accountant"),
                L("2", "Accounts Assistant"),
                L("3", "Accounts Clerk"),
                L("M07", "Accounts Manager"),
                L("A04", "Accounts Staff"),
                L("B76", "Acoustic Engineer"),
                L("04A", "Acrobat"),
                L("4", "Actor"),
                L("5", "Actress"),
                L("A06", "Actuary"),
                L("6", "Acupuncturist"),
                L("7", "Administration Assistant"),
                L("8", "Administration Clerk"),
                L("M08", "Administration Manager"),
                L("05A", "Administration Officer"),
                L("A07", "Administration Staff"),
                L("9", "Administrator"),
                L("A25", "Advertising Agent"),
                L("10", "Advertising Assistant"),
                L("18C", "Advertising Buyer"),
                L("11", "Advertising Clerk"),
                L("680", "Advertising Contractor"),
                L("77A", "Advertising Controller"),
                L("81B", "Advertising Director"),
                L("E27", "Advertising Executive"),
                L("12", "Advertising Manager"),
                L("A08", "Advertising Staff"),
                L("06A", "Advocate"),
                L("13", "Aerial Erector"),
                L("14", "Aerobic Instructor"),
                L("E10", "Aeronautical Engineer"),
                L("01J", "After Dinner Speaker"),
                L("01K", "Agency Staff"),
                L("D79", "Agister"),
                L("B36", "Agricultural Consultant"),
                L("B37", "Agricultural Contractor"),
                L("15", "Agricultural Engineer"),
                L("B38", "Agricultural Merchant"),
                L("B70", "Agricultural Worker"),
                L("07A", "Agriculturalist"),
                L("D80", "Agronomist"),
                L("A09", "Air Traffic Controller"),
                L("392", "Aircraft Buyer"),
                L("A10", "Aircraft Cabin Crew"),
                L("16", "Aircraft Designer"),
                L("559", "Aircraft Engineer"),
                L("08A", "Aircraft Fitter"),
                L("09A", "Aircraft Hand"),
                L("B39", "Aircraft Maintenance Engineer"),
                L("B40", "Aircraft Surface Finisher"),
                L("10A", "Airline Broker"),
                L("17", "Airline Check-in Staff"),
                L("18", "Airman"),
                L("588", "Airport Controller"),
                L("M09", "Airport Manager"),
                L("40A", "Alarm Fitter"),
                L("19", "Almoner"),
                L("B41", "Ambulance Controller"),
                L("A12", "Ambulance Crew"),
                L("D41", "Ambulance Driver"),
                L("A34", "Amusement Arcade Worker"),
                L("20", "Anaesthetist"),
                L("B42", "Analytical Chemist"),
                L("21", "Animal Breeder"),
                L("11A", "Animator"),
                L("12A", "Announcer"),
                L("B86", "Anthropologist"),
                L("A13", "Antique Dealer"),
                L("41C", "Antique Renovator"),
                L("53A", "Appeal/Tribunal Chairman"),
                L("393", "Applications Engineer"),
                L("394", "Applications Programmer"),
                L("13A", "Apprentice"),
                L("D81", "Aquarist"),
                L("22", "Arbitrator"),
                L("B84", "Arborist"),
                L("A14", "Archaeologist"),
                L("14A", "Archbishop"),
                L("15A", "ArchDeacon"),
                L("A15", "Architect"),
                L("23", "Architects Technician"),
                L("B43", "Architectural Surveyor"),
                L("A16", "Archivist"),
                L("M10", "Area Manager"),
                L("B44", "Armourer"),
                L("691", "Aromatherapist"),
                L("16A", "Art Buyer"),
                L("24", "Art Critic"),
                L("A17", "Art Dealer"),
                L("17A", "Art Director"),
                L("A74", "Art Historian"),
                L("B45", "Art Restorer"),
                L("B46", "Artexer"),
                L("25", "Articled Clerk"),
                L("18A", "Artificial Inseminator"),
                L("B71", "Artificial Limb Fitter"),
                L("A18", "Artist"),
                L("20D", "Artist - Commercial"),
                L("21D", "Artist - Freelance"),
                L("19A", "Artist - Portrait"),
                L("20A", "Artist - Technical"),
                L("C93", "Asbestos Remover"),
                L("26", "Asphalter"),
                L("A20", "Assembly Worker"),
                L("A21", "Assessor"),
                L("589", "Assistant Accounts Manager"),
                L("590", "Assistant Caretaker"),
                L("591", "Assistant Cook"),
                L("395", "Assistant Manager"),
                L("592", "Assistant Nurse"),
                L("593", "Assistant Teacher"),
                L("52D", "Associate Director"),
                L("27", "Astrologer"),
                L("28", "Astronomer"),
                L("21A", "Athlete"),
                L("A26", "Au Pair"),
                L("692", "Auction Worker"),
                L("A22", "Auctioneer"),
                L("396", "Audiologist"),
                L("397", "Audit Clerk"),
                L("515", "Audit Manager"),
                L("A23", "Auditor"),
                L("A24", "Author"),
                L("29", "Auto Electrician"),
                L("30", "Auxiliary Nurse"),
                L("31", "Bacon Curer"),
                L("22A", "Bacteriologist"),
                L("B01", "Baggage Handler"),
                L("B02", "Bailiff"),
                L("B03", "Baker"),
                L("560", "Bakery Assistant"),
                L("681", "Bakery Manager"),
                L("594", "Bakery Operator"),
                L("23A", "Ballistics Expert"),
                L("693", "Balloonist"),
                L("32", "Bank Clerk"),
                L("33", "Bank Manager"),
                L("B47", "Bank Messenger"),
                L("398", "Bank Note Checker"),
                L("B04", "Bank Staff"),
                L("81A", "Banking Correspondent"),
                L("595", "Baptist Minister"),
                L("34", "Bar Manager"),
                L("B05", "Bar Staff"),
                L("35", "Bar Steward"),
                L("36", "Barber"),
                L("24A", "Bargeman"),
                L("37", "Barmaid"),
                L("38", "Barman"),
                L("B06", "Barrister"),
                L("25A", "Basket Worker"),
                L("B07", "Beautician"),
                L("596", "Beauty Therapist"),
                L("26A", "BeeKeeper"),
                L("682", "Betting Shop Clerk"),
                L("39", "Bill Poster"),
                L("876", "Bingo Caller"),
                L("694", "Bingo Hall Staff"),
                L("40", "Biochemist"),
                L("41", "Biologist"),
                L("28A", "Biometrician"),
                L("29A", "Biophysicist"),
                L("30A", "Bishop"),
                L("B08", "Blacksmith"),
                L("597", "Blind Assembler"),
                L("516", "Blind Fitter"),
                L("42", "Blinds Installer"),
                L("B09", "Boat Builder"),
                L("32A", "Boatswain"),
                L("598", "Body Fitter"),
                L("D69", "Bodyguard"),
                L("476", "Bodyshop Manager"),
                L("43", "Boiler Maker"),
                L("B10", "Boiler Man"),
                L("44", "Book Binder"),
                L("45", "Book Seller"),
                L("399", "Book-Keeper"),
                L("33A", "Bookfinisher"),
                L("599", "Booking Agent"),
                L("C22", "Booking Clerk"),
                L("400", "Booking Office Clerk"),
                L("34A", "Boom Operator"),
                L("46", "Botanist"),
                L("35A", "Bottler"),
                L("695", "Box Maker"),
                L("B67", "Box Office Clerk"),
                L("M11", "Branch Manager"),
                L("47", "Brewer"),
                L("B48", "Brewery Manager"),
                L("B12", "Brewery Worker"),
                L("B13", "Bricklayer"),
                L("36A", "Bridgeman"),
                L("37A", "Bridgemaster"),
                L("48", "Broadcaster"),
                L("E11", "Broadcasting Engineer"),
                L("38A", "Brother (Church)"),
                L("B15", "Builder"),
                L("49", "Builders Labourer"),
                L("696", "Builders Merchant"),
                L("600", "Building Advisor"),
                L("601", "Building Contractor"),
                L("D47", "Building Control Officer"),
                L("B49", "Building Engineer"),
                L("B50", "Building Estimator"),
                L("50", "Building Foreman"),
                L("401", "Building Inspector"),
                L("39A", "Building Maintenance"),
                L("602", "Building Manager"),
                L("697", "Building Site Inspector"),
                L("C70", "Building Society Agent"),
                L("683", "Building Society Clerk"),
                L("557", "Building Society Staff"),
                L("402", "Building Surveyor"),
                L("B16", "Bursar"),
                L("B17", "Bus Conductor"),
                L("51", "Bus Driver"),
                L("B51", "Bus Mechanic"),
                L("603", "Bus Valeter"),
                L("D93", "Business Analyst"),
                L("B18", "Business Consultant"),
                L("B21", "Butcher"),
                L("684", "Butchery Manager"),
                L("52", "Butler"),
                L("B22", "Buyer"),
                L("53", "Cabinet Maker"),
                L("517", "Cable Contractor"),
                L("B52", "Cable Jointer"),
                L("698", "Cable TV Installer"),
                L("604", "Cafe Owner"),
                L("605", "Cafe Staff"),
                L("686", "Cafe Worker"),
                L("403", "Calibration Manager"),
                L("CA1", "Call Centre Manager"),
                L("CA2", "Call Centre Staff"),
                L("43A", "Calligrapher"),
                L("B53", "Camera Repairer"),
                L("54", "Cameraman"),
                L("B54", "Canal Boat Broker"),
                L("44A", "Canon (Church)"),
                L("45A", "Canvasser"),
                L("46A", "Captain Merchant Ship"),
                L("606", "Car Body Repairer"),
                L("55", "Car Builder"),
                L("607", "Car Dealer"),
                L("D27", "Car Delivery Driver"),
                L("C51", "Car Park Attendant"),
                L("56", "Car Salesman"),
                L("V05", "Car Valet"),
                L("608", "Car Wash Attendant"),
                L("47A", "Cardinal"),
                L("48A", "Cardiographer"),
                L("49A", "Cardiologist"),
                L("C49", "Care Assistant"),
                L("404", "Care Manager"),
                L("518", "Careers Advisor"),
                L("57", "Careers Officer"),
                L("D75", "Carer - Non Professional"),
                L("D89", "Carer - Professional"),
                L("C02", "Caretaker"),
                L("50A", "Cargo Handler"),
                L("699", "Cargo Operator"),
                L("C03", "Carpenter"),
                L("609", "Carpenters Assistant"),
                L("700", "Carpet Cleaner"),
                L("610", "Carpet Retailer"),
                L("C04", "Carpetfitter"),
                L("701", "Carphone Fitter"),
                L("C05", "Cartographer"),
                L("B90", "Cartoonist"),
                L("B55", "Cash Point Fitter"),
                L("C06", "Cashier"),
                L("C07", "Casual Worker"),
                L("51A", "Cataloguer"),
                L("C08", "Caterer"),
                L("B91", "Catering Consultant"),
                L("611", "Catering Manager"),
                L("C10", "Catering Staff"),
                L("59", "Caulker"),
                L("612", "Ceiling Contractor"),
                L("52A", "Ceiling Fitter"),
                L("561", "Ceiling Fixer"),
                L("613", "Cellarman"),
                L("519", "Centre Lathe Operator"),
                L("60", "Certified Accountant"),
                L("C11", "Chambermaid"),
                L("61", "Chandler"),
                L("A91", "Chaplain"),
                L("405", "Charge Hand"),
                L("62", "Charity Worker"),
                L("63", "Chartered Accountant"),
                L("614", "Chartered Engineer"),
                L("64", "Chartered Surveyor"),
                L("D90", "Chartered Valuer"),
                L("C52", "Charterer"),
                L("C12", "Chauffeur"),
                L("877", "Check-out Assistant"),
                L("C13", "Chef"),
                L("E12", "Chemical Engineer"),
                L("65", "Chemist"),
                L("D50", "Chicken Chaser"),
                L("66", "Chicken Sexer"),
                L("615", "Chief Cashier"),
                L("616", "Chief Chemist"),
                L("D62", "Chief Executive"),
                L("54A", "Child Care Officer (Local Government)"),
                L("C14", "Child Minder"),
                L("C50", "Childrens Entertainer"),
                L("C15", "Chimney Sweep"),
                L("702", "China Restorer"),
                L("C16", "Chiropodist"),
                L("68", "Chiropractor"),
                L("55A", "Choirmaster"),
                L("69", "Choreographer"),
                L("56A", "Chorister"),
                L("57A", "Church Army Worker"),
                L("98A", "Church Dean"),
                L("70", "Church Officer"),
                L("71", "Church Warden"),
                L("495", "Cinema Assistant"),
                L("M12", "Cinema Manager"),
                L("B56", "Circus Proprietor"),
                L("C17", "Circus Worker"),
                L("E13", "Civil Engineer"),
                L("C18", "Civil Servant"),
                L("72", "Claims Adjustor"),
                L("73", "Claims Assessor"),
                L("617", "Claims Manager"),
                L("D51", "Clairvoyant"),
                L("59A", "Clapper"),
                L("D48", "Classical Musician"),
                L("406", "Classroom Aide"),
                L("703", "Clay Pigeon Instructor"),
                L("C20", "Cleaner"),
                L("562", "Cleaning Contractor"),
                L("618", "Cleaning Supervisor"),
                L("74", "Clergyman"),
                L("75", "Cleric"),
                L("619", "Clerical Assistant"),
                L("496", "Clerical Officer"),
                L("C21", "Clerk"),
                L("61A", "Clerk of Court"),
                L("C25", "Clerk Of Works"),
                L("620", "Clinical Psychologist"),
                L("76", "Clock Maker"),
                L("01B", "Clothing Design Cutter"),
                L("77", "Coach Builder"),
                L("78", "Coach Driver"),
                L("B57", "Coach Sprayer"),
                L("79", "Coal Merchant"),
                L("64A", "Coalman"),
                L("C27", "Coastguard"),
                L("632", "Cobbler"),
                L("B58", "Coffee Merchant"),
                L("704", "Coin Dealer"),
                L("705", "College Dean"),
                L("621", "College Lecturer"),
                L("B85", "College Principal"),
                L("65A", "College Scout"),
                L("66A", "Colourist (Maps/Photographs)"),
                L("67A", "Comedian"),
                L("80", "Commercial Artist"),
                L("520", "Commercial Manager"),
                L("81", "Commercial Traveller"),
                L("C54", "Commission Agent"),
                L("C29", "Commissionaire"),
                L("82", "Commissioned Officer"),
                L("69A", "Commissioner of Police"),
                L("622", "Commissioning Engineer"),
                L("C30", "Commodity Broker"),
                L("C31", "Commodity Dealer"),
                L("A92", "Communications Officer"),
                L("687", "Communications Supervisor"),
                L("623", "Community Craft Instructor"),
                L("B59", "Community Nurse"),
                L("83", "Community Worker"),
                L("70A", "Companion"),
                L("71A", "Companion Nurse"),
                L("D61", "Company Chairman"),
                L("84", "Company Director"),
                L("C71", "Company Search Agent"),
                L("C32", "Company Secretary"),
                L("72A", "Compiler"),
                L("407", "Complementary Therapist"),
                L("73A", "Compliance Officer"),
                L("85", "Composer"),
                L("C33", "Compositor"),
                L("86", "Computer Analyst"),
                L("C55", "Computer Consultant"),
                L("75A", "Computer Editor"),
                L("87", "Computer Engineer"),
                L("688", "Computer Manager"),
                L("95B", "Computer Network Controller"),
                L("C56", "Computer Operator"),
                L("C57", "Computer Programmer"),
                L("C58", "Computer Technician"),
                L("76A", "Conductor"),
                L("521", "Confectioner"),
                L("B60", "Conference Manager"),
                L("706", "Conference Organiser"),
                L("707", "Conservationist"),
                L("624", "Conservator"),
                L("689", "Construction Engineer"),
                L("C35", "Construction Worker"),
                L("88", "Consultant"),
                L("C59", "Consultant Engineer"),
                L("CA3", "Consumer Scientist"),
                L("477", "Contract Cleaner"),
                L("625", "Contract Furnisher"),
                L("497", "Contract Manager"),
                L("C37", "Contractor"),
                L("626", "Contracts Supervisor"),
                L("89", "Conveyancer"),
                L("90", "Cook"),
                L("91", "Cooper"),
                L("78A", "Copier"),
                L("375", "Coppersmith"),
                L("80A", "Copy Typist"),
                L("384", "Copywriter"),
                L("C38", "Coroner"),
                L("82A", "Correspondent Press"),
                L("C72", "Corrosion Consultant"),
                L("B61", "Costume Designer"),
                L("C60", "Costume Jeweller"),
                L("A93", "Costumier"),
                L("92", "Council Worker"),
                L("93", "Counsellor"),
                L("27A", "Counter Staff"),
                L("708", "Countryside Ranger"),
                L("498", "County Councillor"),
                L("C39", "Courier"),
                L("408", "Court Officer"),
                L("01E", "Court Reporter"),
                L("86A", "Coxswain"),
                L("627", "Craft Dealer"),
                L("C43", "Craftsman"),
                L("628", "Craftswoman"),
                L("94", "Crane Driver"),
                L("D70", "Crane Erector"),
                L("C44", "Crane Operator"),
                L("01F", "Crash Assessor"),
                L("88A", "Creative Director"),
                L("522", "Creche Worker"),
                L("B92", "Credit Broker"),
                L("C53", "Credit Controller"),
                L("B62", "Credit Draper"),
                L("95", "Credit Manager"),
                L("01G", "Credit Researcher"),
                L("A94", "Crematorium Attendant"),
                L("89A", "Cricketer"),
                L("629", "Crime Examiner"),
                L("90A", "Criminologist"),
                L("96", "Crofter"),
                L("C46", "Croupier"),
                L("B82", "Crown Prosecutor"),
                L("92A", "Curate"),
                L("C47", "Curator"),
                L("709", "Currency Trader"),
                L("93A", "Curtain Hanger"),
                L("690", "Curtain Maker"),
                L("409", "PartySearchResult Advisor"),
                L("390", "PartySearchResult Liaison Officer"),
                L("94A", "PartySearchResult Service Controller"),
                L("97", "Customs & Excise Officer"),
                L("98", "Cutler"),
                L("99", "Cutter"),
                L("630", "Cycle Repairer"),
                L("23C", "Cyclist"),
                L("633", "Dairy Engineer"),
                L("D01", "Dairy Worker"),
                L("410", "Dance Teacher"),
                L("100", "Dancer"),
                L("385", "Dark Room Technician"),
                L("634", "Data Administrator"),
                L("635", "Data Co-Ordinator"),
                L("74A", "Data Processing Manager"),
                L("563", "Data Processor"),
                L("523", "Day Care Officer"),
                L("53C", "Day Centre Officer"),
                L("D03", "Dealer - General"),
                L("D44", "Debt Collector"),
                L("636", "Debt Councellor"),
                L("101", "Decorator"),
                L("102", "Delivery Courier"),
                L("637", "Delivery Driver"),
                L("D05", "Delivery Roundsman"),
                L("23D", "Demolition Contractor"),
                L("D06", "Demolition Worker"),
                L("103", "Demonstrator"),
                L("A75", "Dendrochronologist"),
                L("104", "Dental Assistant"),
                L("105", "Dental Hygienist"),
                L("99A", "Dental Mechanic"),
                L("106", "Dental Nurse"),
                L("499", "Dental Surgeon"),
                L("107", "Dental Technician"),
                L("D92", "Dental Therapist"),
                L("108", "Dentist"),
                L("638", "Deputy Head Teacher"),
                L("639", "Deputy Manager"),
                L("640", "Deputy Principal"),
                L("109", "Dermatologist"),
                L("79A", "Design Copier"),
                L("641", "Design Director"),
                L("411", "Design Engineer"),
                L("642", "Design Manager"),
                L("D08", "Designer"),
                L("643", "Despatch Driver"),
                L("644", "Despatch Rider"),
                L("110", "Despatch Worker"),
                L("412", "Development Manager"),
                L("710", "Diamond Dealer"),
                L("524", "Diecaster"),
                L("111", "Dietician"),
                L("112", "Dinner Lady"),
                L("113", "Diplomat"),
                L("08B", "Director of Environment"),
                L("09B", "Director of Housing"),
                L("10B", "Director of Planning"),
                L("D17", "Disc Jockey"),
                L("11B", "Dispenser (Pharmacy)"),
                L("711", "Distillery Worker"),
                L("645", "Distribution Manager"),
                L("12B", "Distributor (Leaflets/Circ.)"),
                L("N03", "District Nurse"),
                L("D19", "District Valuer"),
                L("D20", "Diver"),
                L("13B", "Dock Pilot"),
                L("D21", "Docker"),
                L("114", "Dockyard Worker"),
                L("115", "Doctor"),
                L("646", "Document Controller"),
                L("564", "Dog Beautician"),
                L("116", "Dog Breeder"),
                L("413", "Dog Groomer"),
                L("14B", "Dog Handler"),
                L("647", "Dog Trainer"),
                L("D88", "Dog Walker"),
                L("A84", "Dog Warden"),
                L("B93", "Doll Maker"),
                L("648", "Domestic Staff"),
                L("649", "Door Fitter"),
                L("C28", "Door To Door Collector"),
                L("D24", "Doorman"),
                L("D39", "Double Glazing Fitter"),
                L("117", "Double Glazing Salesman"),
                L("15B", "Draper"),
                L("D25", "Draughtsman"),
                L("650", "Draughtswoman"),
                L("118", "Drayman"),
                L("16B", "Dredger Master"),
                L("17B", "Dredgerman"),
                L("18B", "Dresser Theatre/Films"),
                L("D26", "Dressmaker"),
                L("19B", "Driller (Civil Engineering)"),
                L("712", "Drilling Technician"),
                L("D43", "Driver"),
                L("D37", "Driving Examiner"),
                L("D38", "Driving Instructor"),
                L("D94", "Driving Instructor - Advanced"),
                L("D91", "Driving Instructor (HGV)"),
                L("414", "Drug Addiction Counsellor"),
                L("651", "Dry Cleaner"),
                L("525", "Dryliner"),
                L("119", "Dustman"),
                L("652", "Dye Polisher"),
                L("120", "Dyer"),
                L("E31", "Earth Moving Contractor"),
                L("653", "Ecologist"),
                L("E01", "Economist"),
                L("E02", "Editor"),
                L("C73", "Editorial Consultant"),
                L("713", "Editorial Staff"),
                L("654", "Education Advisor"),
                L("A95", "Education Officer"),
                L("415", "Electrical Contractor"),
                L("21B", "Electrical Contracts Manager"),
                L("E28", "Electrical Engineer"),
                L("655", "Electrical Fitter"),
                L("22B", "Electrical Process Worker"),
                L("E04", "Electrician"),
                L("C74", "Electrologist"),
                L("121", "Electronic Engineer"),
                L("656", "Electronics Supervisor"),
                L("657", "Electronics Technician"),
                L("23B", "Electroplater"),
                L("24B", "Electrotyper"),
                L("122", "Embalmer"),
                L("123", "Embassy Staff"),
                L("B94", "Embroiderer"),
                L("25B", "Embryologist"),
                L("E08", "Emergency Service Staff"),
                L("26B", "Endocrinologist"),
                L("500", "Energy Analyst"),
                L("27B", "Engine Room Man"),
                L("E09", "Engineer"),
                L("71C", "Engineer Stoker"),
                L("28B", "Engineman"),
                L("E22", "Engraver"),
                L("E23", "Enquiry Agent"),
                L("E24", "Entertainer"),
                L("29B", "Entomologist"),
                L("A76", "Environmental Chemist"),
                L("B95", "Environmental Consultant"),
                L("124", "Environmental Health Officer"),
                L("C75", "Equity Agent"),
                L("30B", "Erector"),
                L("E32", "Ergonomist"),
                L("31B", "Escort"),
                L("E25", "Estate Agent"),
                L("658", "Estate Manager"),
                L("E29", "Estimator"),
                L("416", "Evangelist"),
                L("659", "Events Organiser"),
                L("32B", "Examiner"),
                L("417", "Excursion Manager"),
                L("58A", "Executive Officer"),
                L("125", "Exhaust Fitter"),
                L("B96", "Exhibition Designer"),
                L("126", "Exhibition Organiser"),
                L("127", "Exotic Dancer"),
                L("A85", "Expedition Leader"),
                L("33B", "Explosives Worker"),
                L("C76", "Export Consultant"),
                L("714", "Exporter"),
                L("35B", "Extra"),
                L("660", "Extrusion Operator"),
                L("128", "Fabricator"),
                L("661", "Factory Canteen Manager"),
                L("I07", "Factory Inspector"),
                L("662", "Factory Manager"),
                L("F01", "Factory Worker"),
                L("F02", "Fairground Worker"),
                L("B78", "Falconer"),
                L("565", "Farm Manager"),
                L("F03", "Farm Worker"),
                L("F04", "Farmer"),
                L("386", "Farrier"),
                L("D09", "Fashion Designer"),
                L("663", "Fashion Photographer"),
                L("129", "Fast Food Delivery Driver"),
                L("715", "Fast Food Proprieter"),
                L("130", "Fence Erector"),
                L("34B", "Fettler (Foundry)"),
                L("131", "Fibre Glass Moulder"),
                L("A96", "Field Officer"),
                L("664", "Figure Painter"),
                L("60A", "Filing Clerk"),
                L("132", "Film Director"),
                L("41B", "Film Gaffer"),
                L("133", "Film Producer"),
                L("134", "Film Technician"),
                L("418", "Finance Director"),
                L("665", "Finance Manager"),
                L("666", "Finance Officer"),
                L("F05", "Financial Advisor"),
                L("419", "Financial Analyst"),
                L("478", "Financial Consultant"),
                L("F06", "Financier"),
                L("36B", "Finisher"),
                L("B73", "Fire Officer"),
                L("716", "Fire Prevention Officer"),
                L("D60", "Fire Protection Consultant"),
                L("135", "Firefighter"),
                L("667", "Fireplace Fitter"),
                L("668", "Firewood Merchant"),
                L("D97", "First Aid Instructor"),
                L("669", "First Aid Worker"),
                L("670", "Fish Buyer"),
                L("501", "Fish Filleter"),
                L("136", "Fish Fryer"),
                L("671", "Fish Merchant"),
                L("672", "Fish Worker"),
                L("673", "Fisheries Inspector"),
                L("F08", "Fisherman"),
                L("566", "Fishery Manager"),
                L("F09", "Fishmonger"),
                L("137", "Fitness Instructor"),
                L("F10", "Fitter"),
                L("F11", "Fitter - Tyre/Exhaust"),
                L("526", "Flagger"),
                L("86B", "Fleet Manager"),
                L("138", "Flight Deck Crew"),
                L("02B", "Flight Dispatcher"),
                L("420", "Floor Layer"),
                L("421", "Floor Manager"),
                L("F12", "Florist"),
                L("674", "Flour Miller"),
                L("B97", "Flower Arranger"),
                L("387", "Flying Instructor"),
                L("527", "Foam Convertor"),
                L("422", "Food Processor"),
                L("56D", "Footballer - Semi Professional"),
                L("37B", "Footman"),
                L("F14", "Forces - H.M."),
                L("502", "Foreman"),
                L("C77", "Forensic Scientist"),
                L("B75", "Forest Ranger"),
                L("F16", "Forester"),
                L("D28", "Fork Lift Truck Driver"),
                L("38B", "Fortune Teller"),
                L("F17", "Forwarding Agent"),
                L("A97", "Foster Parent"),
                L("88B", "Foundry Moulder"),
                L("139", "Foundry Worker"),
                L("A86", "Fraud Investigator"),
                L("30D", "Freelance Photographer"),
                L("140", "French Polisher"),
                L("676", "Fruiterer"),
                L("141", "Fuel Merchant"),
                L("39B", "Fund Manager"),
                L("F18", "Fund Raiser"),
                L("142", "Funeral Director"),
                L("143", "Funeral Furnisher"),
                L("40B", "Funfair Employee"),
                L("F19", "Furnace Man"),
                L("677", "Furniture Dealer"),
                L("F20", "Furniture Remover"),
                L("F21", "Furniture Restorer"),
                L("F24", "Furrier"),
                L("717", "Gallery Owner"),
                L("718", "Gambler"),
                L("G10", "Gamekeeper"),
                L("C96", "Gaming Board Inspector"),
                L("719", "Gaming Club Manager"),
                L("720", "Gaming Club Proprietor"),
                L("721", "Garage Attendant"),
                L("423", "Garage Foreman"),
                L("722", "Garage Manager"),
                L("B66", "Garda"),
                L("723", "Garden Designer"),
                L("G01", "Gardener"),
                L("144", "Gas Fitter"),
                L("724", "Gas Mechanic"),
                L("145", "Gas Technician"),
                L("D52", "Gate Keeper"),
                L("784", "Genealogist"),
                L("146", "General Manager"),
                L("D22", "General Practitioner"),
                L("42B", "Geneticist"),
                L("43B", "Geographer"),
                L("G09", "Geologist"),
                L("424", "Geophysicist"),
                L("44B", "Geriatrician"),
                L("B79", "Gilder"),
                L("G03", "Glass Worker"),
                L("147", "Glazier"),
                L("G04", "Goldsmith"),
                L("D68", "Golf Caddy"),
                L("A77", "Golf Club Professional"),
                L("45B", "Golf Coach"),
                L("725", "Golfer"),
                L("03B", "Goods Despatcher"),
                L("528", "Goods Handler"),
                L("D57", "Governor"),
                L("726", "Granite Technician"),
                L("D10", "Graphic Designer"),
                L("B74", "Graphologist"),
                L("G05", "Grave Digger"),
                L("727", "Gravel Merchant"),
                L("148", "Green Keeper"),
                L("G06", "Greengrocer"),
                L("728", "Grocer"),
                L("G07", "Groom"),
                L("503", "Ground Worker"),
                L("G08", "Groundsman"),
                L("149", "Guard"),
                L("150", "Guest House Proprietor"),
                L("729", "Guide"),
                L("151", "Gun Smith"),
                L("152", "Gynaecologist"),
                L("46B", "Haematologist"),
                L("75C", "Hair Stylist"),
                L("H01", "Hairdresser"),
                L("529", "Handyman"),
                L("D82", "Harbour Master"),
                L("730", "Hardware Dealer"),
                L("731", "Haulage Contractor"),
                L("H03", "Hawker"),
                L("530", "Head Accurist"),
                L("732", "Head Greenkeeper"),
                L("A78", "Head Lad"),
                L("47B", "Head of Arts"),
                L("48B", "Head of Trade"),
                L("49B", "Head of Traffic"),
                L("H11", "Headteacher"),
                L("567", "Health Advisor"),
                L("733", "Health and Safety Consultant"),
                L("376", "Health And Safety Officer"),
                L("734", "Health Care Assistant"),
                L("735", "Health Planner"),
                L("H04", "Health Service Employee"),
                L("479", "Health Therapist"),
                L("H05", "Health Visitor"),
                L("50B", "Hearing Aid Technician"),
                L("425", "Hearing Therapist"),
                L("153", "Heating & Ventilation Engineer"),
                L("154", "Heating Engineer"),
                L("E14", "Heating/Ventilation Engineer"),
                L("51B", "Hedger/Ditcher"),
                L("52B", "Helmsman"),
                L("155", "Herbalist"),
                L("53B", "Herdsman"),
                L("D29", "HGV Driver"),
                L("736", "HGV Mechanic"),
                L("D53", "Highway Inspector"),
                L("D30", "Hire Car Driver"),
                L("H17", "Hirer"),
                L("54B", "Histologist"),
                L("737", "Historian"),
                L("156", "Hod Carrier"),
                L("D76", "Home Economist"),
                L("H06", "Home Help"),
                L("738", "Homecare Manager"),
                L("157", "Homeopath"),
                L("C90", "Homeworker"),
                L("739", "Hop Merchant"),
                L("158", "Horse Breeder"),
                L("14D", "Horse Dealer (Non Sport)"),
                L("15D", "Horse Dealer (Sport)"),
                L("H12", "Horse Riding Instructor"),
                L("161", "Horse Trader"),
                L("740", "Horse Trainer"),
                L("C78", "Horticultural Consultant"),
                L("H07", "Horticulturalist"),
                L("741", "Hosiery Mechanic"),
                L("742", "Hosiery Worker"),
                L("743", "Hospital Consultant"),
                L("678", "Hospital Doctor"),
                L("744", "Hospital Manager"),
                L("745", "Hospital Orderly"),
                L("55B", "Hospital Photographer"),
                L("426", "Hospital Technician"),
                L("A87", "Hospital Warden"),
                L("746", "Hospital Worker"),
                L("H08", "Hostess"),
                L("747", "Hot Foil Printer"),
                L("B98", "Hotel Consultant"),
                L("748", "Hotel Worker"),
                L("162", "Hotelier"),
                L("427", "House Parent"),
                L("D83", "House Sitter"),
                L("163", "Househusband"),
                L("H10", "Housekeeper"),
                L("56B", "Houseman"),
                L("H09", "Housewife"),
                L("749", "Housing Assistant"),
                L("164", "Housing Officer"),
                L("750", "Housing Supervisor"),
                L("H15", "Human Resources Manager"),
                L("H16", "Human Resources Staff"),
                L("H18", "Hunt Master"),
                L("H19", "Huntsman"),
                L("751", "Hydro Geologist"),
                L("568", "Hygienist"),
                L("752", "Hypnotherapist"),
                L("A98", "Hypnotist"),
                L("I01", "Ice Cream Vendor"),
                L("378", "Illustrator"),
                L("428", "Immigration Officer"),
                L("57B", "Immunologist"),
                L("C79", "Import Consultant"),
                L("58B", "Import/Export Dealer"),
                L("753", "Importer"),
                L("I02", "Independent Means"),
                L("785", "Induction Moulder"),
                L("I03", "Industrial Chemist"),
                L("B99", "Industrial Consultant"),
                L("D11", "Industrial Designer"),
                L("786", "Injection Moulder"),
                L("I04", "Inland Revenue Officer"),
                L("D95", "Insolvency Practitioner"),
                L("I05", "Inspector"),
                L("I09", "Inspector - Insurance"),
                L("59B", "Installation Worker"),
                L("60B", "Instructor"),
                L("429", "Instrument Engineer"),
                L("I10", "Instrument Maker"),
                L("531", "Instrument Supervisor"),
                L("782", "Instrument Technician"),
                L("165", "Insurance Assessor"),
                L("61B", "Insurance Collector"),
                L("787", "Insurance Consultant"),
                L("166", "Insurance Inspector"),
                L("167", "Insurance Representative"),
                L("168", "Interior Decorator"),
                L("D12", "Interior Designer"),
                L("I13", "Interpreter"),
                L("169", "Interviewer"),
                L("D63", "Inventor"),
                L("975", "Investigator"),
                L("D64", "Investment Advisor"),
                L("788", "Investment Banker"),
                L("M13", "Investment Manager"),
                L("62B", "Invigilator"),
                L("63B", "Ironer"),
                L("64B", "Ironer Finisher"),
                L("65B", "Ironer Presser"),
                L("I14", "Ironmonger"),
                L("66B", "Itinerant Labourer"),
                L("67B", "Itinerant Trader"),
                L("870", "IT Consultant"),
                L("871", "IT Manager"),
                L("872", "IT Trainer"),
                L("170", "Janitor"),
                L("789", "Jazz Composer"),
                L("J01", "Jeweller"),
                L("480", "Jewellery Consultant"),
                L("J02", "Jockey"),
                L("J03", "Joiner"),
                L("790", "Joinery Consultant"),
                L("68B", "Jointer"),
                L("J04", "Journalist"),
                L("26D", "Journalist - Freelance"),
                L("C80", "Journalistic Agent"),
                L("J05", "Judge"),
                L("69B", "Juggler"),
                L("791", "Junk Shop Proprietor"),
                L("171", "Justice Of The Peace"),
                L("172", "Keep Fit Instructor"),
                L("C94", "Kennel Hand"),
                L("173", "Kennel Maid"),
                L("70B", "Kiln Setter"),
                L("71B", "Kilnman (Glass/Ceramics)"),
                L("174", "Kissagram Person"),
                L("175", "Kitchen Worker"),
                L("K01", "Knitter"),
                L("795", "Labelling Operator"),
                L("792", "Laboratory Analyst"),
                L("430", "Laboratory Assistant"),
                L("797", "Laboratory Attendant"),
                L("793", "Laboratory Manager"),
                L("796", "Laboratory Operative"),
                L("794", "Laboratory Supervisor"),
                L("L01", "Laboratory Technician"),
                L("L02", "Labourer"),
                L("379", "Laminator"),
                L("C61", "Lampshade Maker"),
                L("L12", "Land Agent"),
                L("C81", "Land Surveyor"),
                L("798", "Landlady"),
                L("176", "Landlord"),
                L("A79", "Landowner"),
                L("532", "Landscape Architect"),
                L("L03", "Landscape Gardener"),
                L("874", "Landworker"),
                L("431", "Lathe Operator"),
                L("177", "Laundry Worker"),
                L("178", "Lavatory Attendant"),
                L("799", "Law Clerk"),
                L("800", "Lawn Mower Repairer"),
                L("L05", "Lawyer"),
                L("801", "Leaflet Distributor"),
                L("179", "Leather Worker"),
                L("L06", "Lecturer"),
                L("802", "Ledger Clerk"),
                L("803", "Legal Advisor"),
                L("504", "Legal Assistant"),
                L("432", "Legal Executive"),
                L("L07", "Legal Secretary"),
                L("180", "Leisure Centre Attendant"),
                L("804", "Leisure Centre Manager"),
                L("35C", "Lengthman"),
                L("181", "Lens Grinder & Polisher"),
                L("805", "Letting Agent"),
                L("72B", "Lexicographer"),
                L("C99", "Liaison Officer"),
                L("L08", "Librarian"),
                L("817", "Library Manager"),
                L("182", "Licensee"),
                L("C62", "Licensing Consultant"),
                L("54D", "Life Assurance Salesman"),
                L("L11", "Lifeguard"),
                L("183", "Lift Attendant"),
                L("184", "Lift Engineer"),
                L("818", "Lighterman"),
                L("D49", "Lighthouse Keeper"),
                L("819", "Lighting Designer"),
                L("73B", "Lighting Director"),
                L("185", "Lighting Technician"),
                L("820", "Lime Kiln Attendant"),
                L("875", "Line Manager"),
                L("186", "Line Worker"),
                L("74B", "Linesman"),
                L("187", "Linguist"),
                L("75B", "Linotype Operator"),
                L("188", "Literary Agent"),
                L("821", "Literary Editor"),
                L("L09", "Lithographer"),
                L("569", "Litigation Manager"),
                L("493", "Loader"),
                L("822", "Loans Manager"),
                L("383", "Local Government Officer"),
                L("D58", "Lock Keeper"),
                L("L10", "Locksmith"),
                L("24D", "Locum Doctor"),
                L("823", "Locum Pharmacist"),
                L("824", "Log Merchant"),
                L("189", "Lorry Driver"),
                L("190", "Loss Adjustor"),
                L("191", "Loss Assessor"),
                L("192", "Lumberjack"),
                L("825", "Machine Fitters Mate"),
                L("826", "Machine Minder"),
                L("M01", "Machine Operator"),
                L("481", "Machine Setter"),
                L("827", "Machine Technician"),
                L("828", "Machine Tool Engineer"),
                L("829", "Machine Tool Fitter"),
                L("M02", "Machinist"),
                L("830", "Magician"),
                L("M03", "Magistrate"),
                L("193", "Magistrates Clerk"),
                L("831", "Maid"),
                L("76B", "Mail Order Worker"),
                L("832", "Maintenance Engineer"),
                L("482", "Maintenance Fitter"),
                L("433", "Maintenance Man"),
                L("833", "Maintenance Manager"),
                L("M04", "Maintenance Staff"),
                L("77B", "Maitre D Hotel"),
                L("505", "Make Up Artist"),
                L("834", "Make Up Supervisor"),
                L("M05", "Management Consultant"),
                L("835", "Management Trainee"),
                L("M06", "Manager"),
                L("M19", "Manager - Sports"),
                L("78B", "Managing Clerk"),
                L("194", "Managing Director"),
                L("195", "Manicurist"),
                L("M23", "Manufacturing Agent"),
                L("79B", "Manufacturing Engineer"),
                L("836", "Manufacturing Technician"),
                L("27D", "Map Maker"),
                L("837", "Map Mounter"),
                L("838", "Marble Finisher"),
                L("839", "Marble Mason"),
                L("C85", "Marine Broker"),
                L("C63", "Marine Consultant"),
                L("840", "Marine Electrician"),
                L("E15", "Marine Engineer"),
                L("841", "Marine Geologist"),
                L("196", "Marine Pilot"),
                L("570", "Marine Surveyor"),
                L("M24", "Market Gardener"),
                L("843", "Market Research Assistant"),
                L("M25", "Market Researcher"),
                L("M26", "Market Trader"),
                L("844", "Marketing Agent"),
                L("197", "Marketing Assistant"),
                L("845", "Marketing Co-ordinator"),
                L("846", "Marketing Consultant"),
                L("847", "Marketing Director"),
                L("198", "Marketing Executive"),
                L("199", "Marketing Manager"),
                L("848", "Marquee Erector"),
                L("849", "Massage Therapist"),
                L("200", "Masseur"),
                L("201", "Masseuse"),
                L("850", "Master Mariner"),
                L("D84", "Master of Ceremonies"),
                L("M53", "Master Of Foxhounds"),
                L("851", "Materials Controller"),
                L("852", "Materials Manager"),
                L("853", "Mathematician"),
                L("434", "Matron"),
                L("854", "Mattress Maker"),
                L("S50", "Mature Student - Living At Home"),
                L("S51", "Mature Student - Living Away"),
                L("855", "Meat Inspector"),
                L("856", "Meat Wholesaler"),
                L("M29", "Mechanic"),
                L("80B", "Mechanical Designer"),
                L("E16", "Mechanical Engineer"),
                L("783", "Mechanical Technician"),
                L("857", "Medal Dealer"),
                L("91A", "Media Critic"),
                L("82B", "Media Planner"),
                L("858", "Medical Advisor"),
                L("859", "Medical Assistant"),
                L("C36", "Medical Consultant"),
                L("06B", "Medical Diagnostician"),
                L("B35", "Medical Officer"),
                L("860", "Medical Physicist"),
                L("B34", "Medical Practitioner"),
                L("861", "Medical Researcher"),
                L("435", "Medical Secretary"),
                L("S48", "Medical Student - Living At Home"),
                L("S49", "Medical Student - Living Away"),
                L("862", "Medical Supplier"),
                L("863", "Medical Technician"),
                L("M45", "Member Of Parliament"),
                L("864", "Merchandiser"),
                L("865", "Merchant Banker"),
                L("202", "Merchant Seaman"),
                L("M34", "Messenger"),
                L("203", "Metal Dealer"),
                L("571", "Metal Engineer"),
                L("506", "Metal Polisher"),
                L("M50", "Metal Worker"),
                L("M35", "Metallurgist"),
                L("M36", "Meteorologist"),
                L("M37", "Meter Reader"),
                L("204", "Microbiologist"),
                L("507", "Microfilm Operator"),
                L("83B", "Microscopist"),
                L("M38", "Midwife"),
                L("C97", "Milklady"),
                L("205", "Milkman"),
                L("866", "Mill Operator"),
                L("206", "Mill Worker"),
                L("207", "Miller"),
                L("M39", "Milliner"),
                L("B80", "Millwright"),
                L("M40", "Miner"),
                L("208", "Mineralologist"),
                L("A88", "Minibus Driver"),
                L("209", "Minicab Driver"),
                L("867", "Mining Consultant"),
                L("E17", "Mining Engineer"),
                L("M41", "Minister Of Religion"),
                L("84B", "Minister Of The Crown"),
                L("B81", "Missionary"),
                L("C09", "Mobile Caterer"),
                L("D18", "Mobile Disc Jockey"),
                L("868", "Mobile Disco Owner"),
                L("210", "Mobile Hairdresser"),
                L("A80", "Mobile Motor Mechanic"),
                L("211", "Mobile Service Engineer"),
                L("M42", "Model"),
                L("869", "Model Maker"),
                L("85B", "Moderator"),
                L("754", "Money Broker"),
                L("806", "Money Dealer"),
                L("M51", "Moneylender"),
                L("D85", "Monk"),
                L("873", "Monumental Sculptor"),
                L("807", "Mooring Contractor"),
                L("212", "Mortgage Broker"),
                L("808", "Mortgage Consultant"),
                L("213", "Mortician"),
                L("809", "Motor Dealer"),
                L("214", "Motor Engineer"),
                L("810", "Motor Fitter"),
                L("215", "Motor Mechanic"),
                L("28D", "Motor Racing Driver"),
                L("811", "Motor Racing Organiser"),
                L("M44", "Motor Trader"),
                L("89B", "Moulding Process Technician"),
                L("812", "Museum Assistant"),
                L("813", "Museum Attendant"),
                L("814", "Museum Consultant"),
                L("436", "Museum Technician"),
                L("91B", "Music Producer"),
                L("508", "Music Teacher"),
                L("815", "Music Therapist"),
                L("816", "Music Wholesaler"),
                L("92B", "Musical Arranger"),
                L("M46", "Musician"),
                L("29D", "Musician - Amateur"),
                L("N08", "Nanny"),
                L("94B", "Naturalist"),
                L("C82", "Naturopath"),
                L("216", "Navigator"),
                L("N01", "Negotiator"),
                L("217", "Neurologist"),
                L("N11", "Newsagent"),
                L("96B", "Newsreader"),
                L("878", "Night Porter"),
                L("218", "Night Watchman"),
                L("219", "Non Commissioned Officer"),
                L("26C", "Non Professional Footballer"),
                L("62A", "Non Professional Sports Coach"),
                L("43D", "Not Employed Due to Disability"),
                L("220", "Not In Employment"),
                L("221", "Notary Public"),
                L("222", "Nuclear Scientist"),
                L("N09", "Nun"),
                L("N02", "Nurse"),
                L("97B", "Nursemaid"),
                L("437", "Nursery Assistant"),
                L("N10", "Nursery Nurse"),
                L("879", "Nursery Worker"),
                L("N05", "Nurseryman"),
                L("533", "Nursing Assistant"),
                L("880", "Nursing Auxilliary"),
                L("572", "Nursing Manager"),
                L("54C", "Nursing Officer"),
                L("D66", "Nursing Sister"),
                L("755", "Nutritionist"),
                L("98B", "Obstetrician"),
                L("C64", "Occupational Health Consultant"),
                L("D54", "Occupational Health Nurse"),
                L("223", "Occupational Therapist"),
                L("224", "Oculist"),
                L("881", "Off Shore Surveyor"),
                L("882", "Office Administrator"),
                L("225", "Office Manager"),
                L("O01", "Office Worker"),
                L("883", "Oil Broker"),
                L("534", "Oil Rig Crew"),
                L("884", "Opera Singer"),
                L("885", "Operations Director"),
                L("99B", "Operations Engineer"),
                L("226", "Operations Manager"),
                L("438", "Operations Supervisor"),
                L("01C", "Opthalmic Surgeon"),
                L("573", "Opthalmic Technician"),
                L("886", "Optical Advisor"),
                L("380", "Optical Assistant"),
                L("535", "Optical Technician"),
                L("O02", "Optician"),
                L("A89", "Optometrist"),
                L("02C", "Orchestra Leader"),
                L("887", "Orchestral Violinist"),
                L("888", "Order Clerk"),
                L("03C", "Orderly"),
                L("227", "Organist"),
                L("889", "Ornamental Blacksmith"),
                L("C91", "Ornithologist"),
                L("890", "Orthopaedic Technician"),
                L("756", "Orthoptist"),
                L("O03", "Osteopath"),
                L("228", "Ostler"),
                L("891", "Outdoor Pursuits Instructor"),
                L("439", "Outfitter"),
                L("892", "Outreach Worker"),
                L("893", "Overhead Line Instructor"),
                L("894", "Overhead Lineman"),
                L("895", "Overlocker"),
                L("896", "Overseas Mailer"),
                L("897", "Overwriter"),
                L("898", "Packaging Consultant"),
                L("P01", "Packer"),
                L("899", "Paediatrician"),
                L("D55", "Pager Operator"),
                L("C83", "Paint Consultant"),
                L("229", "Paint Sprayer"),
                L("01H", "Paint Technologist"),
                L("P02", "Painter"),
                L("P03", "Painter And Decorator"),
                L("B89", "Palaeobotanist"),
                L("D56", "Palaeontologist"),
                L("381", "Pallet Maker"),
                L("230", "Panel Beater"),
                L("900", "Paper Mill Worker"),
                L("D59", "Parachute Packer"),
                L("231", "Paramedic"),
                L("232", "Park Attendant"),
                L("233", "Park Keeper"),
                L("901", "Park Ranger"),
                L("902", "Partition Erector"),
                L("903", "Parts Man"),
                L("483", "Parts Manager"),
                L("536", "Parts Supervisor"),
                L("P05", "Party Planner"),
                L("537", "Pasteuriser"),
                L("904", "Pastry Chef"),
                L("757", "Patent Agent"),
                L("538", "Patent Attorney"),
                L("440", "Pathologist"),
                L("C92", "Patrol Person"),
                L("P41", "Patrolman"),
                L("905", "Pattern Cutter"),
                L("P06", "Pattern Maker"),
                L("906", "Pattern Weaver"),
                L("907", "Paviour"),
                L("P07", "Pawnbroker"),
                L("908", "Payment Officer"),
                L("574", "Payroll Assistant"),
                L("910", "Payroll Clerk"),
                L("911", "Payroll Manager"),
                L("912", "Payroll Supervisor"),
                L("913", "Pearl Stringer"),
                L("P52", "Pedicurist"),
                L("914", "Pensions Consultant"),
                L("915", "Pensions Manager"),
                L("P08", "Personal Assistant"),
                L("P09", "Personnel Administrator"),
                L("234", "Personnel Manager"),
                L("235", "Personnel Officer"),
                L("P10", "Pest Control"),
                L("236", "Pest Controller"),
                L("916", "Pet Minder"),
                L("P11", "Petrol Station Attendant"),
                L("441", "Petroleum Engineer"),
                L("917", "Petty Officer"),
                L("918", "Pharmaceutical Assistant"),
                L("P12", "Pharmacist"),
                L("919", "Pharmacy Manager"),
                L("920", "Pharmacy Technician"),
                L("B87", "Philatelist"),
                L("P50", "Phlebotomist"),
                L("237", "Photo Engraver"),
                L("921", "Photo Laboratory Assistant"),
                L("922", "Photo Technician"),
                L("A99", "Photocopy Machine Technician"),
                L("P13", "Photographer"),
                L("P47", "Photographer - Location"),
                L("05C", "Photographer - Press"),
                L("33D", "Photographer - Press (Local)"),
                L("06C", "Photographer - Shop Owner"),
                L("34D", "Photographer - Street"),
                L("P15", "Photographer - Studio"),
                L("C84", "Photographic Agent"),
                L("923", "Physician"),
                L("238", "Physicist"),
                L("388", "Physiologist"),
                L("P16", "Physiotherapist"),
                L("924", "Piano Teacher"),
                L("P17", "Piano Tuner"),
                L("239", "Picker"),
                L("925", "Picture Editor"),
                L("240", "Picture Framer"),
                L("42C", "Picture Renovator"),
                L("926", "Picture Researcher"),
                L("927", "Pig Man"),
                L("928", "Pig Manager"),
                L("241", "Pilot"),
                L("08C", "Pilot Helicopter"),
                L("09C", "Pilot Test"),
                L("509", "Pipe Fitter"),
                L("758", "Pipe Inspector"),
                L("929", "Pipe Insulator"),
                L("P48", "Pipe Layer"),
                L("575", "Planning Engineer"),
                L("930", "Planning Manager"),
                L("539", "Planning Officer"),
                L("931", "Planning Technician"),
                L("932", "Plant Attendant"),
                L("10C", "Plant Breeder"),
                L("D33", "Plant Driver"),
                L("933", "Plant Engineer"),
                L("934", "Plant Fitter"),
                L("442", "Plant Manager"),
                L("935", "Plant Operator"),
                L("P18", "Plasterer"),
                L("484", "Plastics Consultant"),
                L("540", "Plastics Engineer"),
                L("936", "Plate Layer"),
                L("443", "Plater"),
                L("541", "Playgroup Assistant"),
                L("444", "Playgroup Leader"),
                L("11C", "Playwright"),
                L("P19", "Plumber"),
                L("C98", "Plumbing & Heating Engineer"),
                L("C95", "Podiatrist"),
                L("36C", "Pointsman"),
                L("12C", "Police - Civilian"),
                L("P53", "Police Community Support Officer"),
                L("P20", "Police Officer"),
                L("937", "Polisher"),
                L("242", "Pool Attendant"),
                L("P43", "Pools Collector"),
                L("31D", "Port Officer"),
                L("P21", "Porter"),
                L("938", "Portfolio Manager"),
                L("939", "Post Card Seller"),
                L("18D", "Post Graduate Student Living at Home"),
                L("19D", "Post Graduate Student Living Away from Home"),
                L("244", "Post Office Counter Clerk"),
                L("940", "Post Sorter"),
                L("13C", "Post/Telegraph Officer"),
                L("245", "Postman"),
                L("B27", "Postmaster"),
                L("246", "Postwoman"),
                L("759", "Potato Merchant"),
                L("P24", "Potter"),
                L("15C", "Poultry Worker"),
                L("445", "Practice Manager"),
                L("941", "Preacher"),
                L("16C", "Precious Metal Merchant"),
                L("446", "Precision Engineer"),
                L("B65", "Premises Security Installers"),
                L("83A", "Press Correspondent"),
                L("576", "Press Officer"),
                L("510", "Press Operator"),
                L("35D", "Press Photographer - Freelance"),
                L("36D", "Press Photographer - National"),
                L("17C", "Press Producer"),
                L("942", "Press Setter"),
                L("943", "Presser"),
                L("247", "Priest"),
                L("19C", "Principal"),
                L("248", "Print Finisher"),
                L("P25", "Printer"),
                L("20C", "Printing Press Operator"),
                L("944", "Prison Chaplain"),
                L("P26", "Prison Officer"),
                L("17D", "Private Detective"),
                L("P44", "Private Investigator"),
                L("21C", "Privy Councillor"),
                L("P27", "Probation Officer"),
                L("945", "Probation Worker"),
                L("485", "Process Engineer"),
                L("946", "Process Operator"),
                L("P28", "Process Worker"),
                L("250", "Procurator Fiscal"),
                L("447", "Produce Supervisor"),
                L("P29", "Producer"),
                L("22C", "Product Designer"),
                L("948", "Product Installer"),
                L("448", "Product Manager"),
                L("449", "Production Engineer"),
                L("949", "Production Hand"),
                L("M52", "Production Manager"),
                L("542", "Production Planner"),
                L("24C", "Professional Apprentice Footballer"),
                L("P30", "Professional Boxer"),
                L("32D", "Professional Cricketer"),
                L("37D", "Professional Cyclist"),
                L("25C", "Professional Footballer"),
                L("63A", "Professional Sports Coach"),
                L("P34", "Professional Wrestler"),
                L("251", "Professor"),
                L("950", "Progress Chaser"),
                L("252", "Progress Clerk"),
                L("951", "Project Co-ordinator"),
                L("253", "Project Engineer"),
                L("577", "Project Leader"),
                L("254", "Project Manager"),
                L("952", "Project Worker"),
                L("P35", "Projectionist"),
                L("P36", "Promoter"),
                L("40D", "Promoter - Entertainments"),
                L("P37", "Promoter - Racing"),
                L("P38", "Promoter - Ring Sports"),
                L("41D", "Promoter - Sports"),
                L("511", "Proof Reader"),
                L("255", "Property Buyer"),
                L("256", "Property Dealer"),
                L("P49", "Property Developer"),
                L("257", "Property Manager"),
                L("258", "Property Valuer"),
                L("259", "Proprietor"),
                L("P51", "Prosthetist"),
                L("260", "Psychiatrist"),
                L("A90", "Psychoanalyst"),
                L("953", "Psychodynamic Counsellor"),
                L("261", "Psychologist"),
                L("262", "Psychotherapist"),
                L("486", "Public House Manager"),
                L("P39", "Public Relations Officer"),
                L("P42", "Publican"),
                L("450", "Publicity Manager"),
                L("P40", "Publisher"),
                L("760", "Publishing Manager"),
                L("954", "Purchase Clerk"),
                L("955", "Purchase Ledger Clerk"),
                L("578", "Purchasing Assistant"),
                L("956", "Purchasing Manager"),
                L("263", "Purser"),
                L("Q01", "Quality Controller"),
                L("543", "Quality Engineer"),
                L("957", "Quality Inspector"),
                L("544", "Quality Manager"),
                L("545", "Quality Technician"),
                L("Q02", "Quantity Surveyor"),
                L("264", "Quarry Worker"),
                L("265", "Queens Counsel"),
                L("266", "Rabbi"),
                L("761", "Racehorse Groom"),
                L("29C", "Racing Motorcyclist"),
                L("R01", "Racing Organiser"),
                L("30C", "Radar Mechanic"),
                L("762", "Radio Controller"),
                L("267", "Radio Director"),
                L("958", "Radio Engineer"),
                L("31C", "Radio Helpline Coordinator"),
                L("32C", "Radio Mechanic"),
                L("579", "Radio Operator"),
                L("268", "Radio Presenter"),
                L("269", "Radio Producer"),
                L("R02", "Radiographer"),
                L("451", "Radiologist"),
                L("33C", "Radiotherapist"),
                L("34C", "Railman"),
                L("959", "Rally Driver"),
                L("960", "Ramp Agent"),
                L("R14", "Re-Settlement Officer"),
                L("38C", "Reactor Attendant"),
                L("40C", "Reader"),
                L("39C", "Reader Compositor"),
                L("R04", "Receptionist"),
                L("961", "Records Supervisor"),
                L("962", "Recovery Vehicle Coordinator"),
                L("R13", "Recruitment Consultant"),
                L("270", "Rector"),
                L("R15", "Referee"),
                L("494", "Refit Merchandiser"),
                L("764", "Reflexologist"),
                L("963", "Refractory Engineer"),
                L("763", "Refrigeration Engineer"),
                L("R05", "Refuse Collector"),
                L("42D", "Registered Disabled"),
                L("R06", "Registrar"),
                L("964", "Regulator"),
                L("965", "Relocation Agent"),
                L("966", "Remedial Therapist"),
                L("765", "Rent Collector"),
                L("D67", "Rent Officer"),
                L("967", "Repair Man"),
                L("R07", "Reporter"),
                L("44D", "Reporter - Freelance"),
                L("968", "Reprographic Assistant"),
                L("90B", "Rescue Worker"),
                L("969", "Research Analyst"),
                L("43C", "Research Assistant"),
                L("C65", "Research Consultant"),
                L("452", "Research Director"),
                L("487", "Research Scientist"),
                L("453", "Research Technician"),
                L("R08", "Researcher"),
                L("A81", "Resin Caster"),
                L("271", "Restaurant Manager"),
                L("272", "Restaurateur"),
                L("273", "Restorer"),
                L("R09", "Retired"),
                L("970", "Revenue Clerk"),
                L("454", "Revenue Officer"),
                L("44C", "Rheumatologist"),
                L("R10", "Rig Worker"),
                L("275", "Rigger"),
                L("45C", "Riverman"),
                L("276", "Riveter"),
                L("B28", "Road Safety Officer"),
                L("389", "Road Sweeper"),
                L("277", "Road Worker"),
                L("580", "Roof Tiler"),
                L("R12", "Roofer"),
                L("971", "Rose Grower"),
                L("278", "Royal Marine"),
                L("46C", "Rubber Worker"),
                L("C66", "Rug Maker"),
                L("27C", "Rugby Player"),
                L("38D", "Rugby Player - Amateur"),
                L("39D", "Rugby Player - Professional"),
                L("279", "Saddler"),
                L("512", "Safety Officer"),
                L("280", "Sail Maker"),
                L("455", "Sales Administrator"),
                L("S04", "Sales Assistant"),
                L("456", "Sales Director"),
                L("E18", "Sales Engineer"),
                L("281", "Sales Executive"),
                L("282", "Sales Manager"),
                L("283", "Sales Representative"),
                L("457", "Sales Support"),
                L("D73", "Sales Woman"),
                L("284", "Salesman"),
                L("47C", "Salvage Dealer"),
                L("48C", "Salvage Hand"),
                L("49C", "Sample Hand"),
                L("285", "Sand Blaster"),
                L("50C", "Sand Merchant"),
                L("286", "Saw Miller"),
                L("51C", "Sawyer"),
                L("S05", "Scaffolder"),
                L("52C", "Scenehand"),
                L("84A", "School Counsellor"),
                L("458", "School Crossing Warden"),
                L("B68", "School Inspector"),
                L("74C", "School Student"),
                L("766", "Scientific Officer"),
                L("S06", "Scientist"),
                L("22D", "Scientist - Atomic Energy"),
                L("287", "Scrap Dealer"),
                L("288", "Screen Printer"),
                L("289", "Screen Writer"),
                L("S07", "Script Writer"),
                L("S08", "Sculptor"),
                L("290", "Seaman"),
                L("291", "Seamstress"),
                L("292", "Second Hand Dealer"),
                L("S09", "Secretary"),
                L("459", "Secretary And PA"),
                L("C67", "Security Consultant"),
                L("546", "Security Controller"),
                L("S10", "Security Guard"),
                L("S11", "Security Officer"),
                L("293", "Seedsman"),
                L("294", "Servant"),
                L("E19", "Service Engineer"),
                L("E20", "Service Engineer (Non-Mobile)"),
                L("547", "Service Manager"),
                L("55C", "Setter"),
                L("56C", "Sewage Worker"),
                L("460", "Share Dealer"),
                L("295", "Sheet Metal Worker"),
                L("296", "Shelf Filler"),
                L("767", "Shelter Warden"),
                L("297", "Shepherd"),
                L("298", "Sheriff"),
                L("299", "Sheriff Clerk"),
                L("300", "Sheriff Principal"),
                L("301", "Sheriffs Officer"),
                L("581", "Shift Controller"),
                L("B83", "Ship Broker"),
                L("302", "Ship Builder"),
                L("C23", "Shipping Clerk"),
                L("488", "Shipping Officer"),
                L("303", "Shipwright"),
                L("S13", "Shipyard Worker"),
                L("B69", "Shoe Maker"),
                L("304", "Shoe Repairer"),
                L("768", "Shooting Instructor"),
                L("S14", "Shop Assistant"),
                L("S17", "Shop Fitter"),
                L("305", "Shop Keeper"),
                L("306", "Shop Manager"),
                L("58C", "Shorthand Writer"),
                L("307", "Shot Blaster"),
                L("B72", "Show Jumper"),
                L("S39", "Showman"),
                L("308", "Shunter"),
                L("A82", "Sign Maker"),
                L("309", "Signalman"),
                L("S18", "Signwriter"),
                L("59C", "Silversmith"),
                L("60C", "Singer"),
                L("548", "Site Agent"),
                L("461", "Site Engineer"),
                L("549", "Skipper"),
                L("310", "Slater"),
                L("311", "Slaughterman"),
                L("312", "Smallholder"),
                L("61C", "Smelter"),
                L("28C", "Snooker Player"),
                L("S19", "Social Worker"),
                L("63C", "Sociologist"),
                L("462", "Software Consultant"),
                L("463", "Software Engineer"),
                L("D96", "Solar Panel Installer And Repairer"),
                L("313", "Soldier"),
                L("S20", "Solicitor"),
                L("314", "Song Writer"),
                L("S21", "Sorter"),
                L("64C", "Sound Editor"),
                L("315", "Sound Engineer"),
                L("65C", "Sound Mixer"),
                L("550", "Sound Technician"),
                L("769", "Special Constable"),
                L("B32", "Special Needs Assistant"),
                L("316", "Speech Therapist"),
                L("66C", "Sports Administrator"),
                L("S54", "Sports Agent"),
                L("S40", "Sports Centre Attendant"),
                L("317", "Sports Coach"),
                L("770", "Sports Commentator"),
                L("67C", "Sports Equipment Repairer"),
                L("S55", "Sports Scout"),
                L("318", "Sportsman"),
                L("319", "Sportswoman"),
                L("582", "Spring Maker"),
                L("S24", "Stable Hand"),
                L("489", "Staff Nurse"),
                L("320", "Stage Director"),
                L("322", "Stage Manager"),
                L("323", "Stage Mover"),
                L("68C", "Stamp Dealer"),
                L("69C", "State Enrolled Nurse"),
                L("70C", "State Registered Nurse"),
                L("M20", "Station Manager"),
                L("S43", "Stationer"),
                L("S25", "Statistician"),
                L("324", "Steel Erector"),
                L("S41", "Steel Worker"),
                L("S26", "Steeplejack"),
                L("513", "Stenographer"),
                L("S27", "Stevedore"),
                L("325", "Steward"),
                L("326", "Stewardess"),
                L("S29", "Stock Controller"),
                L("97A", "Stock Exchange Dealer"),
                L("551", "Stock Manager"),
                L("S30", "Stockbroker"),
                L("327", "Stockman"),
                L("771", "Stocktaker"),
                L("552", "Stone Cutter"),
                L("B77", "Stone Sawyer"),
                L("S31", "Stonemason"),
                L("587", "Store Detective"),
                L("72C", "Store Keeper"),
                L("328", "Storeman"),
                L("73C", "Stores Controller"),
                L("329", "Storewoman"),
                L("D71", "Street Entertainer"),
                L("S33", "Street Trader"),
                L("330", "Stud Hand"),
                L("S44", "Student - Living at Home"),
                L("S45", "Student - Living Away"),
                L("85A", "Student Counseller"),
                L("S52", "Student Nurse - Living At Home"),
                L("S53", "Student Nurse - Living Away"),
                L("S46", "Student Teacher - Living At Home"),
                L("S47", "Student Teacher - Living Away"),
                L("553", "Studio Manager"),
                L("B33", "Sub-Postmaster"),
                L("583", "Sub-Postmistress"),
                L("76C", "Superintendent"),
                L("S42", "Supervisor"),
                L("514", "Supply Teacher"),
                L("77C", "Support Worker"),
                L("S36", "Surgeon"),
                L("45D", "Surgeon - N.H.S."),
                L("46D", "Surgeon - Non  N.H.S."),
                L("S37", "Surveyor"),
                L("S38", "Surveyor - Chartered"),
                L("332", "Systems Analyst"),
                L("584", "Systems Engineer"),
                L("464", "Systems Manager"),
                L("C68", "T-Shirt Printer"),
                L("C86", "Tachograph Analyst"),
                L("554", "Tacker"),
                L("T01", "Tailor"),
                L("B88", "Tank Farm Operative"),
                L("976", "Tanker Driver"),
                L("333", "Tanner"),
                L("78C", "Tape Librarian"),
                L("79C", "Tape Operator"),
                L("977", "Tarmacer"),
                L("D74", "Tarot Reader/Palmistry Expert"),
                L("31A", "Taster"),
                L("772", "Tattooist"),
                L("978", "Tax Advisor"),
                L("490", "Tax Analyst"),
                L("979", "Tax Assistant"),
                L("334", "Tax Consultant"),
                L("I08", "Tax Inspector"),
                L("980", "Tax Manager"),
                L("981", "Tax Officer"),
                L("982", "Taxi Controller"),
                L("D34", "Taxi Driver"),
                L("T02", "Taxidermist"),
                L("335", "Tea Blender"),
                L("336", "Tea Taster"),
                L("T03", "Teacher"),
                L("465", "Teachers Assistant"),
                L("983", "Technical Advisor"),
                L("984", "Technical Analyst"),
                L("985", "Technical Assistant"),
                L("337", "Technical Author"),
                L("986", "Technical Clerk"),
                L("987", "Technical Co-ordinator"),
                L("988", "Technical Director"),
                L("989", "Technical Editor"),
                L("990", "Technical Engineer"),
                L("773", "Technical Illustrator"),
                L("774", "Technical Instructor"),
                L("991", "Technical Liaison Engineer"),
                L("992", "Technical Manager"),
                L("14C", "Technician"),
                L("T04", "Technician - Performing Arts"),
                L("80C", "Technologist"),
                L("D65", "Telecommunication Consultant"),
                L("338", "Telecommunications Engineer"),
                L("993", "Telecommunications Manager"),
                L("994", "Telegraphist"),
                L("995", "Telemarketeer"),
                L("339", "Telephone Engineer"),
                L("T05", "Telephonist"),
                L("S02", "Telesales Person"),
                L("340", "Television Director"),
                L("341", "Television Engineer"),
                L("342", "Television Presenter"),
                L("343", "Television Producer"),
                L("92C", "Television Set Builder"),
                L("775", "Telex Operator"),
                L("996", "Temperature Time Recorder"),
                L("997", "Tennis Coach"),
                L("D86", "Terrier"),
                L("81C", "Test Driver"),
                L("82C", "Test Engineer"),
                L("998", "Textile Consultant"),
                L("999", "Textile Engineer"),
                L("A35", "Textile Technician"),
                L("T06", "Textile Worker"),
                L("344", "Thatcher"),
                L("07B", "Theatre Director"),
                L("345", "Theatre Manager"),
                L("A36", "Theatre Technician"),
                L("346", "Theatrical Agent"),
                L("83C", "Theme Park Worker"),
                L("466", "Therapist"),
                L("491", "Thermal Engineer"),
                L("A37", "Thermal Insulator"),
                L("C88", "Ticket Agent"),
                L("37C", "Ticket Collector"),
                L("T07", "Ticket Inspector"),
                L("T24", "Tiler"),
                L("A38", "Timber Inspector"),
                L("A39", "Timber Worker"),
                L("85C", "Time and Motion Analyst"),
                L("T08", "Tobacconist"),
                L("972", "Toll Collector"),
                L("T09", "Tool Maker"),
                L("382", "Tool Setter"),
                L("A40", "Tour Agent"),
                L("347", "Tour Guide"),
                L("A41", "Town Clerk"),
                L("467", "Town Planner"),
                L("T10", "Toy Maker"),
                L("A83", "Toy Trader"),
                L("A42", "Track Worker"),
                L("A43", "Tractor Driver"),
                L("A44", "Tractor Mechanic"),
                L("A45", "Trade Mark Agent"),
                L("T23", "Trade Union Official"),
                L("348", "Trading Standards Officer"),
                L("A46", "Traffic Clerk"),
                L("04B", "Traffic Despatcher"),
                L("A47", "Traffic Engineer"),
                L("A48", "Traffic Officer"),
                L("A49", "Traffic Planner"),
                L("A50", "Traffic Supervisor"),
                L("T11", "Traffic Warden"),
                L("05B", "Train Despatcher"),
                L("D35", "Train Driver"),
                L("87B", "Train Motorman"),
                L("555", "Trainee Manager"),
                L("T12", "Trainer"),
                L("A51", "Training Advisor"),
                L("A52", "Training Assistant"),
                L("A54", "Training Co-ordinator"),
                L("A53", "Training Consultant"),
                L("A55", "Training Instructor"),
                L("468", "Training Manager"),
                L("T16", "Training Officer"),
                L("A56", "Transcriber"),
                L("T17", "Translator"),
                L("86C", "Transmission Controller"),
                L("A57", "Transport Clerk"),
                L("A58", "Transport Consultant"),
                L("469", "Transport Controller"),
                L("470", "Transport Engineer"),
                L("M21", "Transport Manager"),
                L("349", "Transport Officer"),
                L("A59", "Transport Planner"),
                L("87C", "Transport Policeman"),
                L("T18", "Travel Agent"),
                L("A60", "Travel Clerk"),
                L("350", "Travel Consultant"),
                L("351", "Travel Courier"),
                L("A61", "Travel Guide"),
                L("A62", "Travel Guide Writer"),
                L("A63", "Travel Representative"),
                L("88C", "Travelling Salesman/Woman"),
                L("89C", "Trawler Hand"),
                L("A64", "Treasurer"),
                L("352", "Tree Feller"),
                L("T20", "Tree Surgeon"),
                L("C87", "Trichologist"),
                L("T21", "Trinity House Pilot"),
                L("A65", "Trout Farmer"),
                L("90C", "Truck Driver"),
                L("776", "Tug Skipper"),
                L("353", "Tunneller"),
                L("A03", "Turf Accountant"),
                L("A66", "Turkey Farmer"),
                L("354", "Turner"),
                L("355", "Tutor"),
                L("A67", "TV And Video Installer"),
                L("A68", "TV And Video Repairer"),
                L("91C", "TV Announcer"),
                L("47D", "TV Broadcasting Technician"),
                L("A69", "TV Editor"),
                L("356", "Typesetter"),
                L("A70", "Typewriter Engineer"),
                L("T22", "Typist"),
                L("93C", "Typographer"),
                L("A71", "Tyre Builder"),
                L("357", "Tyre Fitter"),
                L("A72", "Tyre Inspector"),
                L("A73", "Tyre Technician"),
                L("25D", "Tyre/Exhaust Fitter"),
                L("U06", "Umpire"),
                L("48D", "Undergraduate Student - Living At Home"),
                L("49D", "Undergraduate Student - Living Away from Home"),
                L("U01", "Undertaker"),
                L("U02", "Underwriter"),
                L("U03", "Unemployed"),
                L("16D", "University Dean"),
                L("94C", "University Reader"),
                L("ZZZ", "Unknown"),
                L("U04", "Upholsterer"),
                L("U05", "Usher"),
                L("95C", "Valet"),
                L("V01", "Valuer"),
                L("777", "Valve Technician"),
                L("D46", "Van Driver"),
                L("96C", "Van Salesman"),
                L("V02", "VDU Operator"),
                L("358", "Vehicle Assessor"),
                L("68A", "Vehicle Bodybuilder"),
                L("97C", "Vehicle Delivery Agent"),
                L("E21", "Vehicle Engineer"),
                L("471", "Vehicle Technician"),
                L("778", "Vending Machine Filler"),
                L("779", "Vending Machine Technician"),
                L("D72", "Ventriloquist"),
                L("472", "Verger"),
                L("V07", "Veterinary Assistant"),
                L("98C", "Veterinary Nurse"),
                L("V04", "Veterinary Surgeon"),
                L("359", "Vicar"),
                L("99C", "Video Supplier"),
                L("01D", "Videotape Engineer"),
                L("492", "Violin Maker"),
                L("02D", "Vision Control Manager"),
                L("03D", "Vision Mixer"),
                L("V06", "Voluntary Worker"),
                L("04D", "Vulcanologist"),
                L("C24", "Wages Clerk"),
                L("360", "Waiter"),
                L("361", "Waitress"),
                L("05D", "Warden"),
                L("06D", "Wardrobe Mistress"),
                L("473", "Warehouse Manager"),
                L("362", "Warehouseman"),
                L("363", "Warehousewoman"),
                L("364", "Waste Dealer"),
                L("07D", "Waste Disposal Worker"),
                L("55D", "Waste Paper Merchant"),
                L("W02", "Watchmaker"),
                L("D87", "Water Diviner"),
                L("365", "Weaver"),
                L("W09", "Web Designer"),
                L("50D", "Web Developer"),
                L("51D", "Web Programmer"),
                L("780", "Weighbridge Clerk"),
                L("781", "Weighbridge Operator"),
                L("W04", "Welder"),
                L("585", "Welfare Assistant"),
                L("366", "Welfare Officer"),
                L("474", "Welfare Rights Officer"),
                L("367", "Wheel Clamper"),
                L("08D", "Wheelwright"),
                L("09D", "Whisky Blender"),
                L("D36", "Wholesale Newspaper Delivery Driver"),
                L("10D", "Will Writer"),
                L("W05", "Window Cleaner"),
                L("368", "Window Dresser"),
                L("F22", "Windscreen Fitter"),
                L("369", "Wine Merchant"),
                L("370", "Wood Carver"),
                L("371", "Wood Cutter"),
                L("11D", "Wood Machinist"),
                L("372", "Wood Worker"),
                L("C69", "Word Processing Operator"),
                L("12D", "Work Study Analyst"),
                L("586", "Works Manager"),
                L("W06", "Writer"),
                L("B63", "Yacht Master"),
                L("13D", "Yard Man"),
                L("556", "Yard Manager"),
                L("Y01", "Yoga Teacher"),
                L("475", "Youth Hostel Warden"),
                L("373", "Youth Worker"),
                L("Z01", "Zoo Keeper"),
                L("B64", "Zoo Manager"),
                L("374", "Zoologist"),
                L("C89", "Zoology Consultant")
            ],
            occupationIndustry: [
                L("188", "Abattoir"),
                L("1", "Accountancy"),
                L("189", "Acoustic Engineer"),
                L("190", "Actuarial Consultancy"),
                L("191", "Acupuncture"),
                L("881", "Addressing/Circularising Services"),
                L("192", "Adjuster"),
                L("2", "Advertising"),
                L("193", "Aerial Erector"),
                L("194", "Aerial Manufacturer"),
                L("195", "Aerial Photography"),
                L("196", "Aerial Supplier"),
                L("197", "Aerial Survey"),
                L("798", "Aerospace Industry"),
                L("198", "Agricultural Engineer"),
                L("882", "Agricultural Produce Distribution"),
                L("199", "Agriculture"),
                L("936", "Air Conditioning"),
                L("200", "Aircraft Construction"),
                L("201", "Aircraft Maintenance"),
                L("202", "Aircraft Repair"),
                L("203", "Airline"),
                L("906", "Airport Services"),
                L("204", "Ambulance Authority"),
                L("5", "Amusement"),
                L("6", "Amusement Arcade"),
                L("205", "Amusement Machine Supplier"),
                L("206", "Animal Breeding"),
                L("799", "Animal Feeds"),
                L("838", "Animal Rescue Home"),
                L("907", "Animal Training"),
                L("898", "Anthropology"),
                L("207", "Antique Restoration"),
                L("8", "Antiques"),
                L("901", "Arable Farming"),
                L("208", "Arbitration"),
                L("977", "Arboriculture"),
                L("9", "Architecture"),
                L("163", "Armed Forces - Foreign"),
                L("162", "Armed Forces - Republic Of Ireland"),
                L("209", "Armed Forces - USA"),
                L("210", "Art"),
                L("211", "Art Gallery"),
                L("212", "Art Restoration"),
                L("213", "Art Valuation"),
                L("214", "Asphalt Contractor"),
                L("215", "Assessor"),
                L("216", "Astrology"),
                L("217", "Astronomy"),
                L("218", "Auction House"),
                L("14", "Auctioneer"),
                L("808", "Auditors"),
                L("952", "Auxiliary Plant"),
                L("219", "Baby Food Manufacturer"),
                L("220", "Baby Goods Manufacturer"),
                L("221", "Baby Goods Shop"),
                L("222", "Bagpipe Maker"),
                L("223", "Bakers Supplies"),
                L("224", "Bakery"),
                L("15", "Banking"),
                L("225", "Barrel Makers"),
                L("226", "Bathroom Design"),
                L("227", "Bathroom Installation"),
                L("171", "Beauticians"),
                L("809", "Beauty Salon"),
                L("944", "Bed And Breakfast - Licensed"),
                L("945", "Bed And Breakfast - Unlicensed"),
                L("228", "Betting Shop"),
                L("955", "Bicycle Manufacture"),
                L("839", "Bingo Hall"),
                L("229", "Blacksmith"),
                L("230", "Blast Cleaning"),
                L("231", "Blind Installation"),
                L("232", "Blind Manufacturer"),
                L("233", "Boarding Kennel"),
                L("234", "Boat Builder"),
                L("235", "Boat Hirer"),
                L("236", "Bookmaker - Off Course"),
                L("237", "Bookmaker - On Course"),
                L("238", "Booksellers"),
                L("239", "Bottled Gas Supplier"),
                L("240", "Brass Foundry"),
                L("241", "Breakdown Recovery"),
                L("242", "Breeding"),
                L("18", "Brewery"),
                L("243", "Brewery Transport"),
                L("244", "Brick Manufacturer"),
                L("245", "Brick Supplier"),
                L("933", "British Army"),
                L("19", "Broadcasting"),
                L("246", "Builder"),
                L("247", "Builders Merchant"),
                L("20", "Building Society"),
                L("21", "Building Trade"),
                L("248", "Business Consultancy"),
                L("822", "Business Systems"),
                L("249", "Business Training"),
                L("250", "Butchers"),
                L("251", "Cabinet Maker"),
                L("252", "Cable Manufacturer"),
                L("840", "Cable TV Installation"),
                L("253", "Cafe"),
                L("254", "Camp Site"),
                L("255", "Candle Dealer"),
                L("256", "Car Accessory Dealer"),
                L("257", "Car Delivery"),
                L("258", "Car Hire"),
                L("259", "Car Park Operator"),
                L("260", "Car Sales"),
                L("261", "Car Valeting"),
                L("262", "Caravan Hirer"),
                L("970", "Caravan Park - Residential"),
                L("263", "Caravan Sales"),
                L("264", "Caravan Service"),
                L("265", "Caravan Site"),
                L("266", "Carpentry"),
                L("267", "Carpet Fitting"),
                L("268", "Cartography"),
                L("269", "Cash & Carry"),
                L("23", "Casino"),
                L("270", "Cask Maker"),
                L("884", "Catalogue Co-ordination"),
                L("883", "Catalogue Distribution"),
                L("24", "Catering - Licensed"),
                L("25", "Catering - Unlicensed"),
                L("271", "Cattery"),
                L("913", "Ceiling Contractor"),
                L("272", "Cement Suppliers"),
                L("273", "Central Heating Services"),
                L("26", "Charity"),
                L("274", "Chartering"),
                L("810", "Chemical Industry"),
                L("817", "Chemical Manufacturer"),
                L("275", "Chemist Shop"),
                L("854", "Child Minding"),
                L("958", "Childrens Home"),
                L("276", "Childrens Panel"),
                L("277", "Chimney Sweeping"),
                L("278", "Chiropody"),
                L("279", "Choreography"),
                L("960", "Church"),
                L("959", "Church Army"),
                L("27", "Cinema"),
                L("28", "Circus"),
                L("893", "Citizens Advice Bureau"),
                L("280", "Civil Aviation"),
                L("281", "Civil Engineering"),
                L("29", "Civil Service"),
                L("282", "Cleaning Services"),
                L("885", "Clerical Services"),
                L("283", "Clock & Watch Manufacturer"),
                L("284", "Clock & Watch Repair"),
                L("858", "Clothing Manufacturer"),
                L("31", "Clothing Trade"),
                L("32", "Club"),
                L("285", "Coach Hirer"),
                L("286", "Coachbuilder"),
                L("33", "Coal Industry"),
                L("287", "Coal Merchant"),
                L("288", "Coffee Shop"),
                L("289", "Coin & Medal Dealer"),
                L("290", "Cold Store"),
                L("291", "Commissioners For Oaths"),
                L("34", "Commodities"),
                L("292", "Commodity Brokerage"),
                L("293", "Communications"),
                L("294", "Community Service"),
                L("818", "Computer Aided Design"),
                L("824", "Computer Distribution"),
                L("812", "Computer Sales"),
                L("295", "Computer Services"),
                L("886", "Computer Supplies"),
                L("181", "Computers"),
                L("35", "Computers - Hardware"),
                L("36", "Computers - Software"),
                L("296", "Concrete Supplier"),
                L("297", "Confectionery Manufacturer"),
                L("160", "Construction Industry"),
                L("298", "Consulting Engineering"),
                L("299", "Contact Lens Manufacturer"),
                L("300", "Container Hire"),
                L("301", "Conveyancers"),
                L("825", "Corporate Hospitality"),
                L("811", "Cosmetics"),
                L("302", "Costumiers"),
                L("303", "Cotton Mill"),
                L("953", "Country Court"),
                L("304", "Courier Services"),
                L("305", "Crane Hire"),
                L("306", "Crane Manufacturer"),
                L("149", "Crop Spraying"),
                L("38", "Customs and Excise"),
                L("307", "Cutlery Craftsmen"),
                L("308", "Cycle Hire"),
                L("309", "Cycle Shop"),
                L("39", "Dairy"),
                L("900", "Dairy Farming"),
                L("954", "Dance Band"),
                L("310", "Data Processing"),
                L("311", "Data Protection"),
                L("911", "Dating Agency"),
                L("962", "Day Centre"),
                L("40", "Debt Collection"),
                L("312", "Decorating"),
                L("866", "Delicatessen"),
                L("313", "Delivery Service"),
                L("41", "Demolition"),
                L("42", "Dentistry"),
                L("314", "Department Store"),
                L("833", "Design Consultancy"),
                L("887", "Desktop Publishing Services"),
                L("315", "Despatch Services"),
                L("44", "Discotheque"),
                L("316", "Distillers"),
                L("813", "Distribution"),
                L("317", "DIY Store"),
                L("318", "Dock Authority"),
                L("157", "Domestic Appliance Maintenance"),
                L("319", "Domestic Service"),
                L("172", "Double Glazing"),
                L("937", "Drainage"),
                L("45", "Drapery"),
                L("320", "Driving Authority"),
                L("46", "Driving Instruction"),
                L("321", "Driving School"),
                L("800", "Dry Cleaning"),
                L("938", "Dry Lining"),
                L("322", "Earth Removers"),
                L("897", "Ecology"),
                L("323", "Education"),
                L("47", "Education - Private"),
                L("138", "Education - State"),
                L("324", "Effluent Disposal"),
                L("325", "Egg Merchants"),
                L("823", "Electrical Appliance Manufacturer"),
                L("326", "Electrical Contractors"),
                L("834", "Electrical Goods Consultancy"),
                L("48", "Electricity Industry"),
                L("49", "Electronics"),
                L("327", "Embossers"),
                L("50", "Emergency Services"),
                L("328", "Employment Agency"),
                L("939", "Energy Conservation"),
                L("329", "Energy Consultancy"),
                L("956", "Energy Supplier"),
                L("139", "Engineering"),
                L("330", "Engineering Consultants"),
                L("182", "Engraving"),
                L("51", "Entertainment"),
                L("869", "Environmental Health"),
                L("52", "Estate Agency"),
                L("331", "Excavation"),
                L("332", "Exhibition Centre"),
                L("333", "Exhibition Organisers"),
                L("334", "Export"),
                L("335", "Export Agency"),
                L("336", "Exporter"),
                L("337", "Fabric Manufacturer"),
                L("867", "Fabrications"),
                L("53", "Fairground"),
                L("876", "Falconry"),
                L("168", "Fancy Goods"),
                L("338", "Fancy Goods Importer"),
                L("54", "Farming"),
                L("920", "Fascia Board Installer"),
                L("55", "Fashion"),
                L("339", "Fashion Design"),
                L("340", "Fashion House"),
                L("841", "Fast Food"),
                L("341", "Fencing Manufacturer"),
                L("342", "Ferry Service"),
                L("343", "Fertilizer Manufacturer"),
                L("344", "Fibre Glass Manufacturer"),
                L("345", "Filling Station"),
                L("346", "Film Manufacturing"),
                L("347", "Film Processing"),
                L("348", "Film Production"),
                L("349", "Finance Company"),
                L("350", "Financial Advisors"),
                L("56", "Financial Services"),
                L("351", "Fire Protection"),
                L("963", "Fire Service"),
                L("352", "Fireplace Installer"),
                L("353", "Fireplace Manufacturer"),
                L("982", "Fireworks / Pyrotechnics"),
                L("354", "Fish & Chip Shop"),
                L("355", "Fish Farm"),
                L("150", "Fish Merchants"),
                L("943", "Fisheries"),
                L("842", "Fishing"),
                L("926", "Fishing Rights"),
                L("356", "Fishmonger"),
                L("914", "Fitted Bedroom Installer"),
                L("915", "Fitted Kitchen Installer"),
                L("916", "Flooring Construction"),
                L("918", "Flooring Installer"),
                L("917", "Flooring Services"),
                L("357", "Florists"),
                L("358", "Flying School"),
                L("359", "Food Exporter"),
                L("360", "Food Importer"),
                L("361", "Food Manufacturer"),
                L("814", "Food Production"),
                L("362", "Food Store"),
                L("363", "Football Pools"),
                L("364", "Forestry"),
                L("843", "Fostering/Adoption Agency"),
                L("365", "Foundry"),
                L("366", "Freezer Centre"),
                L("183", "Freight"),
                L("367", "Freight Agents"),
                L("815", "Freight Forwarders"),
                L("870", "French Polishing"),
                L("368", "Friendly Society"),
                L("871", "Frozen Food Distribution"),
                L("369", "Fuel Distribution"),
                L("370", "Fuel Merchant"),
                L("173", "Funeral Director"),
                L("964", "Funfair"),
                L("371", "Fur Trade"),
                L("925", "Furniture Installer"),
                L("372", "Furniture Manufacture"),
                L("373", "Furniture Remover"),
                L("374", "Furniture Repair"),
                L("375", "Furniture Sales"),
                L("376", "Furniture Store"),
                L("377", "Furniture Storer"),
                L("378", "Furriers"),
                L("57", "Gambling"),
                L("379", "Game Breeders"),
                L("58", "Garage"),
                L("826", "Garden Centre"),
                L("380", "Gardening"),
                L("844", "Gas - Offshore"),
                L("381", "Gas Exploration"),
                L("59", "Gas Industry"),
                L("855", "Genealogy"),
                L("61", "General Dealer"),
                L("382", "General Store"),
                L("383", "Gift Shop"),
                L("384", "Glass Manufacture"),
                L("385", "Glaziers"),
                L("386", "Golf Club"),
                L("151", "Government - Foreign"),
                L("152", "Government - Republic Of Ireland"),
                L("387", "Government - UK"),
                L("388", "Gown Trade"),
                L("389", "Grain Merchants"),
                L("390", "Grain Mill"),
                L("895", "Graphic Design"),
                L("879", "Graphology"),
                L("391", "Greengrocer"),
                L("392", "Greeting Card Manufacturer"),
                L("393", "Greeting Card Sales"),
                L("394", "Greyhound Racing"),
                L("65", "Greyhounds"),
                L("395", "Grit Blasters"),
                L("396", "Grocer"),
                L("397", "Ground Maintenance"),
                L("829", "Guest House - Licensed"),
                L("830", "Guest House - Unlicensed"),
                L("919", "Guttering Installer"),
                L("965", "Gymnasium"),
                L("66", "Hairdressing"),
                L("399", "Harbour Authority"),
                L("67", "Harbour Board"),
                L("400", "Hardware Manufacturer"),
                L("401", "Hardware Retailer"),
                L("174", "Haulage Contractors"),
                L("979", "Hazardous Chemical Transport"),
                L("402", "Health Authority"),
                L("68", "Health Care - NHS"),
                L("69", "Health Care - Private"),
                L("403", "Health Centre"),
                L("404", "Health Club"),
                L("889", "Health Products Distribution"),
                L("405", "Heating Consultant"),
                L("406", "Heating Services"),
                L("407", "Hire Purchase"),
                L("408", "HM Forces"),
                L("409", "Hobby Shop"),
                L("410", "Holiday Accommodation"),
                L("70", "Holiday Camp"),
                L("411", "Holiday Centre"),
                L("412", "Home Help Services"),
                L("888", "Honey Producer"),
                L("71", "Horses"),
                L("184", "Horticulture"),
                L("413", "Hospital"),
                L("72", "Hotel - Licensed"),
                L("73", "Hotel - Unlicensed"),
                L("414", "House Builders"),
                L("415", "Housing Association"),
                L("416", "Housing Developers"),
                L("417", "Hypermarket"),
                L("74", "Ice Cream"),
                L("418", "Ice Cream Manufacturer"),
                L("419", "Ice Cream Shop"),
                L("420", "Ice Merchant"),
                L("421", "Ice Rink"),
                L("422", "Import"),
                L("423", "Importers"),
                L("424", "Industrial Building Manufacturer"),
                L("425", "Industrial Relations"),
                L("904", "Information Technology"),
                L("76", "Inland Revenue"),
                L("426", "Inn"),
                L("427", "Inspection Services"),
                L("428", "Instant Print Services"),
                L("429", "Insulation Engineers"),
                L("77", "Insurance"),
                L("430", "Insurance Advisor"),
                L("431", "Insurance Broker"),
                L("432", "Insurance Company"),
                L("433", "Insurance Consultant"),
                L("801", "Interior Design"),
                L("78", "Investment"),
                L("434", "Iron Foundry"),
                L("890", "Ironing Services"),
                L("435", "Ironmonger"),
                L("436", "Jam & Preserve Manufacturer"),
                L("437", "Jewellers"),
                L("185", "Jewellery"),
                L("438", "Jewellery Manufacturer"),
                L("439", "Joinery"),
                L("440", "Keep Fit"),
                L("441", "Kennels"),
                L("442", "Kitchen Equipment Manufacturer"),
                L("835", "Kitchen Manufacturer"),
                L("443", "Kitchen Planners"),
                L("444", "Knitwear Manufacturer"),
                L("445", "Laboratory"),
                L("446", "Ladder Manufacturer"),
                L("447", "Land Clearance"),
                L("448", "Land Draining"),
                L("449", "Landscaping"),
                L("450", "Lathe Manufacturer"),
                L("451", "Launderette"),
                L("153", "Laundry"),
                L("79", "Law and Order"),
                L("452", "Lawnmowers & Garden Machinery"),
                L("453", "Lawyers"),
                L("454", "Leasing Company"),
                L("455", "Legal System"),
                L("175", "Leisure Centre"),
                L("930", "Leisure Goods"),
                L("456", "Lens Manufacturer"),
                L("457", "Library"),
                L("966", "Life Assurance"),
                L("458", "Lift Installers"),
                L("459", "Lift Maintenance"),
                L("940", "Lighting"),
                L("460", "Lighting Installers"),
                L("461", "Linen Hire"),
                L("462", "Livery Stables"),
                L("463", "Livestock Carriers"),
                L("902", "Livestock Farming"),
                L("63", "Local Government"),
                L("464", "Local Government Authority"),
                L("465", "Local Newspaper"),
                L("466", "Locksmiths"),
                L("467", "Loft Insulation"),
                L("82", "Log And Firewood"),
                L("468", "Loss Adjusting"),
                L("469", "LPG Suppliers"),
                L("470", "Machine Tool Supplier"),
                L("471", "Machinery Dealers"),
                L("83", "Mail Order"),
                L("472", "Mail Order Supplier"),
                L("473", "Maintenance Services"),
                L("474", "Management Consultancy"),
                L("475", "Management Training"),
                L("476", "Mantle Trade"),
                L("84", "Manufacturing"),
                L("477", "Manufacturing Chemist"),
                L("802", "Marina"),
                L("478", "Market Garden"),
                L("85", "Market Gardeners"),
                L("868", "Market Research"),
                L("479", "Market Trading"),
                L("480", "Marketing"),
                L("481", "Marriage Guidance"),
                L("482", "Material Manufacturer"),
                L("483", "Mattress Manufacturer"),
                L("484", "Meat Market"),
                L("485", "Meat Products"),
                L("486", "Mechanical Handling"),
                L("803", "Medical research"),
                L("487", "Medical Suppliers"),
                L("972", "Meditation"),
                L("86", "Merchant Navy"),
                L("488", "Metal Founders"),
                L("489", "Metal Treatment"),
                L("490", "Microfilm Services"),
                L("967", "Military Police"),
                L("491", "Milk Delivery"),
                L("87", "Mining"),
                L("88", "Mobile Food"),
                L("492", "Mobile Shop"),
                L("875", "Model Manufacturer"),
                L("89", "Moneylenders"),
                L("493", "Monumental Masons"),
                L("845", "Motor Factor/Parts"),
                L("142", "Motor Manufacture"),
                L("143", "Motor Organisation"),
                L("90", "Motor Trade"),
                L("91", "Motorcar Racing"),
                L("92", "Motorcycle Racing"),
                L("903", "Motorcycle Trade"),
                L("494", "Motoring Organisation"),
                L("836", "Museums"),
                L("495", "Music Publisher"),
                L("496", "Music Retailer"),
                L("497", "Music School"),
                L("498", "Musical Instrument Manufacturer"),
                L("499", "National Newspaper"),
                L("856", "National Trust"),
                L("857", "National Trust For Scotland"),
                L("500", "Newsagents"),
                L("909", "Newspaper Wholesaler"),
                L("93", "Night Club"),
                L("819", "Noise Control"),
                L("948", "None - Household Duties"),
                L("949", "None - Not Employed due to Disability"),
                L("947", "None - Retired"),
                L("950", "None - Student"),
                L("747", "None - Unemployed"),
                L("186", "Not In Employment"),
                L("501", "Notaries"),
                L("141", "Nuclear Energy"),
                L("95", "Nursery"),
                L("502", "Nursery School"),
                L("503", "Nursing Home"),
                L("846", "Oceanographic Survey"),
                L("96", "Off Licence"),
                L("504", "Off Licence Store"),
                L("921", "Office Equipment Repairer"),
                L("505", "Office Equipment Supplier"),
                L("506", "Office Fitters"),
                L("507", "Office Services"),
                L("847", "Oil - Offshore"),
                L("508", "Oil Company"),
                L("980", "Oil Distribution"),
                L("509", "Oil Exploration"),
                L("865", "Oil Terminal Operator"),
                L("510", "Opinion Polls"),
                L("97", "Optical Services"),
                L("511", "Optician"),
                L("512", "Optometrist"),
                L("961", "Orchestra"),
                L("513", "Organ Building"),
                L("905", "Outdoor Pursuits"),
                L("514", "Overall Hire & Maintenance"),
                L("515", "Packers And Storers"),
                L("516", "Paint Manufacturer"),
                L("517", "Paint Spraying"),
                L("518", "Painting"),
                L("98", "Painting and Decorating"),
                L("859", "Painting Contractor"),
                L("519", "Panel Beating"),
                L("804", "Paper Manufacture"),
                L("520", "Paperbag And Sack Manufacturer"),
                L("521", "Parcel Delivery"),
                L("923", "Partition Erector"),
                L("522", "Passenger Transport"),
                L("848", "Patent Office"),
                L("523", "Pawnbroker"),
                L("12", "Performing Arts"),
                L("524", "Personnel Consultancy"),
                L("525", "Pest And Vermin Control"),
                L("927", "Pet Feed"),
                L("908", "Pet Services"),
                L("526", "Pet Shop"),
                L("100", "Petrochemical Industry"),
                L("527", "Petrol Pump Maintenance"),
                L("816", "Petrol Station"),
                L("528", "Pharmaceutical Supplier"),
                L("529", "Pharmacy"),
                L("530", "Photo Engraving"),
                L("531", "Photo Processing And Printing"),
                L("532", "Photographic Equipment Repairs"),
                L("101", "Photography"),
                L("533", "Physiotherapy"),
                L("534", "Piano Sales And Repairs"),
                L("535", "Piano Tuning"),
                L("872", "Picture Framing"),
                L("536", "Pig Farming"),
                L("537", "Pipe Cleaning"),
                L("538", "Pizza Delivery"),
                L("539", "Planning Consultancy"),
                L("102", "Plant Hire"),
                L("540", "Plant Manufacturer"),
                L("541", "Plant Sales"),
                L("542", "Plastic Sheeting Manufacturer"),
                L("805", "Plastics Manufacture"),
                L("543", "Playground Equipment Manufacturer"),
                L("544", "Plumbers Merchant"),
                L("103", "Plumbing"),
                L("896", "Plumbing & Heating"),
                L("545", "Political Consultancy"),
                L("546", "Political Party"),
                L("547", "Pollution Control"),
                L("969", "Polytechnic"),
                L("931", "Pony Trap"),
                L("548", "Pool Table Manufacturer"),
                L("549", "Pool Table Repairer"),
                L("550", "Pool Table Sales"),
                L("968", "Pop Group"),
                L("144", "Port Authority"),
                L("932", "Portable Building"),
                L("104", "Post Office"),
                L("552", "Potato Merchant"),
                L("553", "Pottery"),
                L("554", "Poultry Farm"),
                L("899", "Poultry Farming"),
                L("555", "Pre-Stressed Concrete Manufacturer"),
                L("556", "Presentation Materials Supplier"),
                L("557", "Press Cutting Agency"),
                L("558", "Pressure Cleaning"),
                L("559", "Print Type Services"),
                L("176", "Printer"),
                L("560", "Printing"),
                L("561", "Printing Engineering Services"),
                L("105", "Prison Service"),
                L("562", "Private Hire"),
                L("563", "Private Investigation"),
                L("564", "Private School"),
                L("565", "Process Engraving"),
                L("566", "Produce Importers"),
                L("567", "Project Management"),
                L("568", "Promotional Consultancy"),
                L("820", "Property Consultants"),
                L("106", "Property Developers"),
                L("821", "Property Letting"),
                L("569", "Property Holder"),
                L("107", "Property Services"),
                L("570", "Protective Clothing Manufacturer"),
                L("571", "Protective Clothing Supplier"),
                L("572", "Psychiatry"),
                L("573", "Psychology"),
                L("574", "Psychotherapy"),
                L("575", "Public Address System Supplier"),
                L("576", "Public Hire"),
                L("577", "Public Hirer"),
                L("578", "Public House"),
                L("579", "Public Relation Consultancy"),
                L("580", "Public School"),
                L("894", "Public Transport"),
                L("108", "Publishing"),
                L("109", "Publishing - Local Press"),
                L("110", "Publishing - National Press"),
                L("581", "Quality Assurance"),
                L("582", "Quantity Surveyors"),
                L("583", "Quarry"),
                L("111", "Quarrying"),
                L("584", "Race Course"),
                L("112", "Racehorses"),
                L("113", "Racing Or Rallies"),
                L("585", "Racing Stable"),
                L("586", "Radiator Repairs"),
                L("587", "Radiator Sales"),
                L("951", "Radio Production"),
                L("588", "Radiography"),
                L("589", "Rag Merchants"),
                L("114", "Railway"),
                L("590", "Rating And Valuation"),
                L("591", "Record Company"),
                L("592", "Record Shop"),
                L("593", "Recording Services"),
                L("594", "Recovery Services"),
                L("595", "Recruitment Agency"),
                L("596", "Recycling"),
                L("597", "Refrigeration"),
                L("598", "Refuse Collection"),
                L("941", "Refuse Treatment"),
                L("599", "Reinforced Concrete Manufacturer"),
                L("115", "Religion"),
                L("177", "Removal Contractors"),
                L("600", "Remover And Storer"),
                L("601", "Rescue Services"),
                L("602", "Residential Home"),
                L("831", "Restaurant - Licensed"),
                L("832", "Restaurant - Unlicensed"),
                L("154", "Retailer - Mobile"),
                L("117", "Retailing"),
                L("603", "Riding School"),
                L("807", "Ring Sports"),
                L("604", "River Authority"),
                L("605", "Road Haulage"),
                L("606", "Road Repair"),
                L("607", "Road Surfacing"),
                L("849", "Robotics Manufacturer"),
                L("608", "Roller Shutter Manufacturer"),
                L("609", "Roofing Services"),
                L("610", "Rope Merchant"),
                L("611", "Roughcasters"),
                L("935", "Royal Air Force"),
                L("975", "Royal Mint"),
                L("934", "Royal Navy"),
                L("850", "RSPCA"),
                L("612", "Rubbish Disposal"),
                L("613", "Rubble Removers"),
                L("614", "Rustproofing Services"),
                L("615", "Saddlers And Harness Makers"),
                L("616", "Safe Installation And Removal"),
                L("617", "Safe Manufacturer"),
                L("618", "Safety Consultancy"),
                L("619", "Safety Equipment Supplier"),
                L("620", "Sail Makers And Repairers"),
                L("621", "Sailing Equipment Supplier"),
                L("622", "Salvage"),
                L("891", "Sample Distribution"),
                L("623", "Sample Distributors"),
                L("624", "Sand And Gravel Merchants"),
                L("625", "Sand Blasters"),
                L("626", "Satellite TV And Equipment Suppliers"),
                L("627", "Satellite TV Installers"),
                L("628", "Saw Sales And Repairs"),
                L("629", "Sawmill"),
                L("630", "Scaffolding Erection"),
                L("631", "Scaffolding Hire"),
                L("632", "School"),
                L("873", "School For Performing Arts"),
                L("851", "Scientific Research"),
                L("633", "Scrap Disposal"),
                L("634", "Scrap Metal Merchants"),
                L("635", "Screen Printing"),
                L("636", "Screenwriting"),
                L("637", "Sculptors"),
                L("638", "Secondhand Dealers"),
                L("639", "Secretarial Services"),
                L("640", "Secretarial Training"),
                L("860", "Security Equipment"),
                L("120", "Security Services"),
                L("641", "Seedsmen"),
                L("642", "Self Catering Accommodation"),
                L("643", "Self Drive Hire"),
                L("942", "Sewage"),
                L("644", "Sharpening Services"),
                L("645", "Sheet Metal Work"),
                L("646", "Sheriff Officers"),
                L("647", "Ship Building And Repair"),
                L("648", "Ship Chandlery"),
                L("649", "Ship Painting"),
                L("650", "Shipbroking"),
                L("651", "Shipping And Forwarding Agency"),
                L("652", "Shipping Company"),
                L("122", "Shipyard"),
                L("653", "Shoe Manufacturers"),
                L("654", "Shoe Repair"),
                L("655", "Shoe Shop"),
                L("928", "Shooting Rights"),
                L("656", "Shop Fitting"),
                L("657", "Shopping Centre"),
                L("658", "Shot Blasters"),
                L("659", "Shutter Manufacturer"),
                L("660", "Sightseeing Tours Operator"),
                L("661", "Sign Making"),
                L("123", "Signwriting"),
                L("662", "Site Clearance"),
                L("663", "Site Investigation"),
                L("664", "Skating Rink"),
                L("665", "Ski Centre"),
                L("666", "Skip Hire"),
                L("827", "Skip Maintenance"),
                L("667", "Slaughterhouse"),
                L("892", "Slimming Distribution"),
                L("668", "Snack Bar"),
                L("669", "Snooker Club"),
                L("670", "Social Club"),
                L("124", "Social Services"),
                L("671", "Soft Drinks Manufacturer"),
                L("672", "Soft Drinks Supplier"),
                L("673", "Soil Engineers"),
                L("674", "Solar Panel Manufacturer"),
                L("675", "Solar Panel Supplier"),
                L("178", "Solicitors"),
                L("676", "Sound Proofing"),
                L("677", "Spinners"),
                L("125", "Sports"),
                L("974", "Sports - Non Professional"),
                L("126", "Sports - Professional"),
                L("678", "Sports Centre"),
                L("679", "Sports Club"),
                L("971", "Sports Club - Professonal"),
                L("680", "Sports Goods Shop"),
                L("681", "Sports Ground"),
                L("682", "Sports Promotion"),
                L("683", "Sportswear Manufacturer"),
                L("684", "Sportswear Supplier"),
                L("685", "Stables"),
                L("686", "Stamp Dealers"),
                L("687", "Stamp Manufacturer"),
                L("688", "Stamp Supplier Stationers"),
                L("957", "State School"),
                L("874", "Stationers"),
                L("127", "Steel Industry"),
                L("689", "Steel Stockholders"),
                L("690", "Sterilizing Services"),
                L("128", "Stockbroking"),
                L("691", "Stonemasonry"),
                L("692", "Street Trading"),
                L("693", "Structural Engineering"),
                L("694", "Studio"),
                L("929", "Sunbed"),
                L("179", "Supermarket"),
                L("695", "Surveying"),
                L("180", "Surveyors"),
                L("922", "Suspended Ceiling Repairer"),
                L("696", "Swimming Pool"),
                L("697", "Tailor And Outfitter"),
                L("698", "Take Away Food Supplier"),
                L("699", "Tank Cleaning Services"),
                L("700", "Tarpaulin Manufacturer"),
                L("701", "Tarpaulin Suppliers"),
                L("912", "Tattoo Parlour/Clinic"),
                L("702", "Tax Consultancy"),
                L("703", "Taxi Service"),
                L("704", "Taxidermy"),
                L("705", "Tea Importer"),
                L("706", "Tea Merchant"),
                L("707", "Tea Room"),
                L("708", "Technical College"),
                L("709", "Telecommunication Equipment Suppliers"),
                L("130", "Telecommunications"),
                L("710", "Telemarketing"),
                L("711", "Telephone Answering Service"),
                L("712", "Telesales"),
                L("166", "Television"),
                L("806", "Television Hire"),
                L("713", "Television Production"),
                L("714", "Television Repairer"),
                L("715", "Television Sales"),
                L("716", "Tent And Marquee Hirer"),
                L("837", "Territorial Army"),
                L("717", "Textile Manufacturer"),
                L("718", "Thatching"),
                L("167", "Theatre"),
                L("719", "Theatrical Suppliers"),
                L("853", "Theme Park"),
                L("720", "Tilers"),
                L("721", "Timber Importers"),
                L("156", "Timber Merchants"),
                L("722", "Timber Preservation"),
                L("723", "Timeshare Operators"),
                L("724", "Tobacco Importer"),
                L("725", "Tobacco Manufacturer"),
                L("726", "Tobacconist"),
                L("727", "Tomato Grower"),
                L("728", "Tool Hire"),
                L("729", "Tour Operator"),
                L("730", "Tourist Board"),
                L("731", "Tourist Information"),
                L("732", "Towel Supplier"),
                L("733", "Toy And Game Manufacturer"),
                L("734", "Toy And Game Supplier"),
                L("159", "Trade Association"),
                L("187", "Trade Demonstration"),
                L("158", "Trade Union"),
                L("735", "Trading Estate"),
                L("736", "Trading Standards Enforcement"),
                L("737", "Trailer Manufacturer"),
                L("738", "Trailer Supplier"),
                L("946", "Training Company"),
                L("924", "Training Consultancy"),
                L("739", "Translators"),
                L("131", "Transport - PSV"),
                L("132", "Transport - Road"),
                L("145", "Travel And Tourism"),
                L("978", "Tree Surgery"),
                L("740", "Trinity House"),
                L("910", "Trust Company"),
                L("169", "Tupperware"),
                L("133", "Turf Accountants"),
                L("741", "TV And Radio"),
                L("852", "TV And Video Rental"),
                L("742", "Typewriter Services"),
                L("863", "Tyre Dealer"),
                L("864", "Tyre Manufacturer"),
                L("743", "Tyre Supplier And Fitting"),
                L("744", "Undertaker"),
                L("745", "Underwater Inspection"),
                L("746", "Underwriting Agency"),
                L("748", "Uniform Manufacturer"),
                L("749", "University"),
                L("999", "Unknown"),
                L("750", "Upholstery"),
                L("751", "Vacuum Cleaner Repairs And Service"),
                L("752", "Valuation"),
                L("753", "Van And Lorry Hirer"),
                L("155", "Vehicle Hire - Self Drive"),
                L("754", "Vehicle Repairer"),
                L("981", "Vehicle Transport"),
                L("755", "Vending Machine Manufacturer"),
                L("756", "Vending Machine Supplier"),
                L("828", "Vending Services"),
                L("757", "Veneering"),
                L("758", "Venetian Blind Manufacturer"),
                L("759", "Venetian Blind Supplier"),
                L("760", "Ventilation"),
                L("761", "Vermin Control"),
                L("134", "Veterinary"),
                L("762", "Veterinary Supplies"),
                L("763", "Veterinary Surgeons"),
                L("135", "Video Hire"),
                L("764", "Video Services"),
                L("765", "Vineyard"),
                L("766", "Voluntary Organisation"),
                L("767", "Wallpaper Manufacturer/Supplier"),
                L("768", "Washing Machine Repairs And Servicing"),
                L("769", "Waste Disposal"),
                L("976", "Waste Paper"),
                L("770", "Watchmaker"),
                L("136", "Water Industry"),
                L("771", "Water Sports Centre"),
                L("772", "Waterproof Cover Manufacturer"),
                L("773", "Waterproof Cover Supplier"),
                L("774", "Weather Forecasting"),
                L("775", "Weather Services"),
                L("776", "Weights And Measures"),
                L("777", "Welding"),
                L("778", "Welfare Organisation"),
                L("779", "Whisky Blenders"),
                L("137", "Wholesaler"),
                L("780", "Window Cleaning"),
                L("781", "Wine And Spirit Merchants"),
                L("782", "Wine Bar"),
                L("783", "Wine Makers"),
                L("784", "Wire Rope Manufacturer"),
                L("785", "Wood Carving"),
                L("786", "Wood Preservation"),
                L("880", "Woodshavings Contractor"),
                L("787", "Woodworking"),
                L("788", "Woodworm And Dry Rot Control"),
                L("789", "Woollen Goods Manufacturer"),
                L("790", "Woollen Goods Shop"),
                L("791", "Woollen Mill"),
                L("792", "Wrought Iron Manufacturer"),
                L("793", "Yacht Building"),
                L("794", "Yacht Chandlery"),
                L("877", "Yacht Service And Management"),
                L("795", "Yarn Spinning"),
                L("796", "Youth Hostel Organisation"),
                L("878", "Youth Organisation"),
                L("797", "Zoo Operator")
            ],
            educationType: [
                L("S50", "Mature Student - Living At Home"),
                L("S51", "Mature Student - Living Away"),
                L("S48", "Medical Student - Living At Home"),
                L("S49", "Medical Student - Living Away"),
                L("18D", "Post Graduate Student Living at Home"),
                L("19D", "Post Graduate Student Living Away from Home"),
                L("74C", "School Student"),
                L("S44", "Student - Living at Home"),
                L("S45", "Student - Living Away"),
                L("85A", "Student Counseller"),
                L("S52", "Student Nurse - Living At Home"),
                L("S53", "Student Nurse - Living Away"),
                L("S46", "Student Teacher - Living At Home"),
                L("S47", "Student Teacher - Living Away"),
                L("48D", "Undergraduate Student - Living At Home"),
                L("49D", "Undergraduate Student - Living Away from Home")
            ],
            vehicleManufacturer: [
                L("Audi", "Audi"),
                L("BMW", "BMW"),
                L("Ford", "Ford"),
                L("Mazda", "Mazda"),
                L("Mercedes", "Mercedes"),
                L("Toyota", "Toyota"),
                L("Volkswagen", "Volkswagen"),
                L("Volvo", "Volvo"),
                L("MITSUBISHI", "MITSUBISHI")
            ],
            vehicleModel: [
                L("A4", "A4"),
                L("530i", "530i"),
                L("Focus", "Focus"),
                L("636", "636"),
                L("E220", "E220"),
                L("Avensis", "Avensis"),
                L("Golf", "Golf"),
                L("V70", "V70"),
                L("LANCER GS4", "LANCER GS4")
            ],
            vehicleFuelType: [
                L("P", "Petrol"),
                L("D", "Diesel"),
                L("H", "Hybrid"),
                L("E", "Electric")
            ],
            vehicleTransmission: [
                L("M", "Manual"),
                L("A", "Automatic"),
                L("SA", "Semi-auto"),
                L("CVT", "CVT")
            ],
            vehicleYear: [
                L("1", "2001"),
                L("2", "2002"),
                L("3", "2003"),
                L("4", "2004"),
                L("5", "2005"),
                L("6", "2006"),
                L("7", "2007"),
                L("8", "2008"),
                L("9", "2009"),
                L("10", "2010"),
                L("11", "2011"),
                L("12", "2012"),
                L("13", "2013"),
                L("14", "2014"),
                L("15", "2015"),
                L("16", "2016"),
                L("17", "2017"),
                L("18", "2018"),
                L("19", "2019")
            ],
            vehicleModification: [
                L("C0016", "Car Phones"),
                L("C0023", "Driving Lights"),
                L("C0026", "Emergency Services Blue Light"),
                L("C0033", "Fog Lamps"),
                L("C0046", "Neon Lights"),
                L("C0054", "Rally Lights"),
                L("C0065", "Spot Lights"),
                L("C0003", "Additional Windows"),
                L("C0009", "Body Kit"),
                L("C0010", "Bonnet Bulge"),
                L("C0013", "Bull Bars"),
                L("C0014", "Cabriolet Conversion"),
                L("C0015", "Camper Van Conversion"),
                L("C0017", "Carbon Fibre Bonnet"),
                L("C0030", "Fibreglass Panels"),
                L("C0031", "Flared Wheelarches"),
                L("C0032", "Flared Wings"),
                L("C0034", "Front Spoiler/Airdam"),
                L("C0055", "Rear Spoiler/Aerofoil"),
                L("C0056", "Rear Valance"),
                L("C0061", "Side Skirts/Sills"),
                L("C0068", "Strengthening Brackets"),
                L("C0070", "Sunroof"),
                L("C0073", "Tinted Windows"),
                L("C0012", "Braided Brake Hoses"),
                L("C0037", "High Level Brake Light"),
                L("C0079", "Uprated Brakes"),
                L("C0001", "Adapted For Disability"),
                L("C0007", "Altered Pedal Configuration"),
                L("C0036", "Hand Controls"),
                L("C0083", "Wheelchair modifications"),
                L("C0005", "Air Filter"),
                L("C0008", "Blueprinting"),
                L("C0011", "Bored-out Engine"),
                L("C0018", "Chipping - Engine Management System Changes"),
                L("C0022", "De-Restrictor Kits"),
                L("C0025", "Dump Valve"),
                L("C0027", "Engine remap"),
                L("C0028", "Engine Tuned"),
                L("C0029", "Exhaust System Changes"),
                L("C0035", "Gearing Change"),
                L("C0038", "Induction kit"),
                L("C0039", "Intercooler"),
                L("C0042", "LPG Conversion"),
                L("C0044", "Miscellaneous Engine Alterations"),
                L("C0047", "Nitrous Oxide Kit Fitted"),
                L("C0049", "Non-standard Engine"),
                L("C0051", "Petrol Tank Changes"),
                L("C0052", "Power Boost Valve"),
                L("C0053", "Quick Shift Gear Lever"),
                L("C0066", "Standard Engine Replacement"),
                L("C0071", "Supercharging"),
                L("C0076", "Transmission Changes"),
                L("C0077", "Turbocharging"),
                L("C0002", "Additional Seating"),
                L("C0004", "Air Conditioning"),
                L("C0019", "Dashboard Changes"),
                L("C0024", "Dual Controls"),
                L("C0040", "Interior Changes"),
                L("C0057", "Removal/Replacement of seats"),
                L("C0058", "Roll Cage/bars"),
                L("C0059", "Seatbelt Harnesses"),
                L("C0060", "Seats - Custom"),
                L("C0064", "Sports Steering Wheel"),
                L("C0078", "Upholstery Changes"),
                L("C0050", "Other"),
                L("C0021", "Decals/Stickers"),
                L("C0043", "Magnetic/Removable Signs"),
                L("C0045", "Murals"),
                L("C0048", "Non standard Paintwork"),
                L("C0062", "Side Stripes"),
                L("C0080", "Vinyl Wrap Bodywork"),
                L("C0067", "Steering Change"),
                L("C0069", "Struct Brace"),
                L("C0072", "Suspension Changes"),
                L("C0006", "Alloy wheels (non standard)"),
                L("C0041", "Locking Wheel Nuts"),
                L("C0063", "Slick Tyres"),
                L("C0081", "Wheel Spacers"),
                L("C0082", "Wheel Trims"),
                L("C0084", "Wheels - Alloy"),
                L("C0085", "Wider Tyres"),
                L("C0086", "Wider Wheels")
            ],
            rentersClaimType: [
                L("10", "Accidental damage"),
                L("11", "Accidental loss"),
                L("12", "Escape of water/oil"),
                L("13", "Earthquake"),
                L("14", "Fire"),
                L("15", "Flood (river/sea etc.)"),
                L("16", "Impact"),
                L("17", "Legal liability"),
                L("18", "Storm"),
                L("19", "Subsidence/heave/landslip"),
                L("20", "Theft"),
                L("21", "Vandalism")
            ],
            homeClaimType: [
                L("24", "Accidental damage"),
                L("25", "Escape of water"),
                L("26", "Escape of water due to Freezing"),
                L("27", "Earthquake"),
                L("28", "Fire / Lightning / Explosion / Smoke damage"),
                L("29", "Flood by drains / surface water"),
                L("30", "Flood by river water"),
                L("31", "Flood by sea water"),
                L("32", "Freeze / burst pipes"),
                L("33", "Impact by vehicle / falling tree / other"),
                L("34", "Liability - property owners"),
                L("35", "Liability - personal/occupiers"),
                L("36", "Loss of freezer contents"),
                L("37", "Loss of oil"),
                L("38", "Property lost away from the home"),
                L("39", "Property lost in the home"),
                L("40", "Storm damage"),
                L("41", "Subsidence / Landslip / Heave damage"),
                L("42", "Theft away from home"),
                L("43", "Theft from home"),
                L("44", "Trace and access"),
                L("45", "Vandalism"),
                L("46", "Riot"),
                L("47", "Drains and underground tanks"),
                L("48", "Other"),
                L("49", "Arson"),
                L("50", "Home emergency"),
            ],
            incidentFault: [
                L("1", "Claimant"),
                L("2", "Other Party"),
                L("3", "Both Parties")
            ],
            excessAmountValues: [
                L("100", "£100"),
                L("200", "£200"),
                L("300", "£300")
            ],
            voluntaryExcess: [
                L("1", "0"),
                L("2", "50"),
                L("3", "100"),
                L("4", "150"),
                L("5", "200"),
                L("6", "250"),
                L("7", "300"),
                L("8", "350"),
                L("9", "400"),
                L("10", "450"),
                L("11", "500")
            ],
            carsInHouseHold: [
                L("1", "1"),
                L("2", "2"),
                L("3", "3"),
                L("4", "4"),
                L("5", "5+")
            ],
            bedroomCount: [
                L("1", "1"),
                L("2", "2"),
                L("3", "3"),
                L("4", "4"),
                L("5", "5+")
            ],
            bathroomCount: [
                L("1", "1"),
                L("2", "2"),
                L("3", "3"),
                L("4", "4"),
                L("5", "5+")
            ],
            cancellationReasons: [
                //default(no value) - cool of period (internal process)
                //2 - transfer of vehicle (internal process)
                L("3", "Total Loss"),
                L("4", "Policy Restrictions"),
                L("5", "Linked & Organised"),
                L("6", "Ghost Broking"),
                L("7", "Fraud"),
                L("8", "Claims fraud (internal)"),
                L("9", "Fronting"),
                L("10", "False ID/ Address Concerns"),
                L("11", "Disclosure of Claims history"),
                L("12", "Policy transaction history"),
                L("13", "Void Insurance"),
                L("14", "Policy holder deceased"),
                //15 - change driver decline (internal process)
                //16 - change address decline (internal process)
                //17 - change vehicle decline (internal process)
                L("18", "Chargeback / payment fraud")
            ],
            adultFamilyMembersAtProperty: [
                L("0", "None"),
                L("1", "1"),
                L("2", "2"),
                L("3", "3"),
                L("4", "4"),
                L("5", "5"),
                L("6", "6+"),
            ],
            housematesAtProperty: [
                L("0", "None"),
                L("1", "1"),
                L("2", "2"),
                L("3", "3+"),
            ],
            furnishingType: [
                L('FURNISHED_PRIVATE_LANDLORD', 'Furnished from private landlord'),
                L('UNFURNISHED_PRIVATE_LANDLORD', 'Unfurnished from private landlord'),
                L('RENTED_HOUSING_ASSOCIATION', 'Rented from housing association'),
                L('RENTED_COUNCIL', 'Rented from the council'),
                L('OTHER', 'Other')
            ],
            realEstateTypeSubType: [
                L('HOUSE_DETACHED', 'Detached house'),
                L('HOUSE_SEMI_DETACHED', 'Semi-detached house'),
                L('HOUSE_MID_TERRACED', 'Mid terraced house'),
                L('HOUSE_END_TERRACED', 'End terraced house'),
                L('BUNGALOW_DETACHED', 'Detached bungalow'),
                L('BUNGALOW_SEMI_DETACHED', 'Semi-detached bungalow'),
                L('BUNGALOW_MID_TERRACED', 'Mid terraced bungalow'),
                L('BUNGALOW_END_TERRACED', 'End terraced bungalow'),
                L('FLAT_BASEMENT', 'Basement flat'),
                L('FLAT_GROUND_FLOOR', 'Ground floor flat'),
                L('FLAT_FIRST_FLOOR_AND_ABOVE', 'First floor and above flat'),
                L('TOWNHOUSE_DETACHED', 'Detached townhouse'),
                L('TOWNHOUSE_MID_TERRACED', 'Mid terraced townhouse'),
                L('TOWNHOUSE_END_TERRACED', 'End terraced townhouse'),
                L('MAISONETTE_NO_OPTIONS', 'Maisonette'),
                L('OTHER_NO_OPTIONS', 'Other')
            ],
            convictionOffenceCodes: [
                L("N536", "4104001     Causing death by reckless driving"),
                L("N537", "4104002     Causing death by dangerous driving"),
                L("N400", "5008001     Jay walking"),
                L("N001", "5008007     Breach of Signal Given by a Constable"),
                L("N401", "5008008     Failing to stop for police"),
                L("N043", "5008013     Excess Speed"),
                L("N402", "5008018     Furious driving"),
                L("N002", "5008019     Driving or permitting a person to drive motor vehicle while"),
                L("N051", "5008028     Failing to stop where accident occurred causing damage"),
                L("N054", "5008031     Failing to give particulars where accident occurred causing"),
                L("N055", "5008032     Failing to stop where accident occurred causing injury"),
                L("N058", "5008035     Failing to give particulars injury accident"),
                L("N403", "5008040     Failure to give information regarding driver"),
                L("N404", "5008067     Parking on yellow line"),
                L("N405", "5008068     Parking within 15 metre of junction"),
                L("N406", "5008069     Parking at a bus stop"),
                L("N407", "5008070     Parking on a footway adjacent to Clearway"),
                L("N408", "5008071     Parking in a clearway AM"),
                L("N409", "5008072     Parking in a clearway PM"),
                L("N003", "5008073     Parking within the limits of a Pelican Crossing"),
                L("N004", "5008075     Unlawful use of central reservation of Motorway"),
                L("N005", "5008076     Reversing on Motorway"),
                L("N006", "5008077     Driving on hard shoulder of Motorway"),
                L("N007", "5008078     Parking on hard shoulder of Motorway"),
                L("N410", "5008079     Pedestrian on Motorway"),
                L("N060", "5008080     Breach of box junction"),
                L("N061", "5008083     Failing to drive in nearside lane"),
                L("N062", "5008084     Overtaking on inside"),
                L("N008", "5008086     Parking within the limits of a Zebra Crossing"),
                L("N009", "5008087     Driving classified vehicle on special road"),
                L("N411", "5008088     Parking so as to obstruct access"),
                L("N010", "5008089     Remain on hard shoulder of motorway longer than necessary"),
                L("N412", "5008090     Parking in a disabled person's parking space"),
                L("N063", "5008091     Interfering with traffic sign"),
                L("N042", "5008092     Stopping On A Motorway"),
                L("N413", "5008098     Parking within the limits of a taxi stand"),
                L("N046", "5008101     Incorrectly parked at parking space"),
                L("N414", "5008102     Unauthorised vehicle in a parking place"),
                L("N415", "5008107     Parking in an urban clearway (Portadown)"),
                L("N416", "5008109     Parking without payment"),
                L("N417", "5008110     Incorrectly parking in layby"),
                L("N012", "5008111     Stopping on approach to a Pelican Crossing"),
                L("N418", "5008114     Failing to give precedence to pedestrian at a pelican crossi"),
                L("N013", "5008115     Stopping within limits the of Zebra Controlled area"),
                L("N419", "5008116     Pedestrian remaining on zebra crossing longer than necessary"),
                L("N014", "5008117     Overtaking Moving Vehicle on Zebra Crossing"),
                L("N421", "5008122     Manoeuvring vehicle without signalling"),
                L("N066", "5008123     Driving while unfit through drink/drugs"),
                L("N067", "5008124     Attempting to drive when unfit through drink/drugs"),
                L("N068", "5008125     In charge of a vehicle when unfit through drink/drugs"),
                L("N069", "5008126     Driving with excess alcohol in breath"),
                L("N070", "5008127     Attempting to drive with excess alcohol in breath"),
                L("N072", "5008129     Driving with excess alcohol in blood"),
                L("N073", "5008130     Attempting to drive with excess alcohol in blood"),
                L("N075", "5008132     Driving with excess alcohol in urine"),
                L("N076", "5008133     Attempting to drive with excess alcohol in urine"),
                L("N422", "5008136     Failing to provide a specimen of breath for analysis"),
                L("N080", "5008139     Failure to provide a specimen when attempting to drive unfit"),
                L("N083", "5008142     Failing to provide a specimen when attempting to drive with"),
                L("N423", "5008145     Failing to display a valid parking ticket"),
                L("N424", "5008149     Wrongful use of a disabled person's badge"),
                L("N425", "5008151     Parking in a suspended bay"),
                L("N089", "5008201     Dangerous driving"),
                L("N090", "5008202     Driving without due care and attention"),
                L("N091", "5008203     Driving without reasonable consideration for other road user"),
                L("N426", "5008204     Causing death through driving carelessly when unfit"),
                L("N427", "5008208     Causing death through driving carelessly with excess alcohol"),
                L("N428", "5008212     Causing death by careless driving then failing to supply a s"),
                L("N429", "5008218     Driver of motorcycle failing to wear protective headgear"),
                L("N430", "5008219     Rider on motorcycle failing to wear protective headgear"),
                L("N432", "5008230     Parking HGV unlawfully (verge;footway;central reservation)"),
                L("N015", "5008231     Leaving vehicle in dangerous position"),
                L("N433", "5008232     Causing dangerous article to be on road"),
                L("N016", "5008237     Carrying unauthorised passenger on motorbicycle"),
                L("N434", "5008240     Unlawfully moving vehicle for a purpose of being drawn"),
                L("N435", "5008247     Dangerous cycling"),
                L("N436", "5008258     Driving on land other than a road"),
                L("N437", "5008267     Parking otherwise than at side of carriageway"),
                L("N017", "5008268     Breach of Traffic Sign eg No Entry, Red Light"),
                L("N096", "5008269     Breach of traffic sign"),
                L("N438", "5008271     Breach of junction; Waiting restriction Belfast City"),
                L("N439", "5008272     Waiting within the limits of a bus stop Belfast City"),
                L("N440", "5008273     Waiting so as to obstruct access to premises Belfast City"),
                L("N441", "5008274     Waiting otherwise that at the side of the carriageway Belfas"),
                L("N442", "5008275     Waiting within the limits of taxi stand Belfast City"),
                L("N018", "5008286     Driving on a Buslane on Motorway"),
                L("N443", "5008290     Aggravated vehicle taking causing injury"),
                L("N100", "5008291     Excess speed for vehicle classification"),
                L("N444", "5008295     Aggravated vehicle taking causing damage"),
                L("N445", "5008312     Driving while disqualified"),
                L("N446", "5010003     Driving a vehicle having failed to notify a disability"),
                L("N019", "5010007     No L Plates displayed"),
                L("N020", "5010009     Unaccompanied L Driver"),
                L("N021", "5010010     L Driver carrying passenger on motorcycle"),
                L("N022", "5010011     L Driver carrying unauthorised passenger on motorcycle"),
                L("N023", "5010012     L Driver Towing a Trailer"),
                L("N024", "5010015     No R Plates Displayed"),
                L("N129", "5010026     Exceeding 45 MPH while displaying R plates"),
                L("N130", "5010029     Exceeding 45 MPH while displaying L plates"),
                L("N447", "5012006     Being unauthorised passenger on goods vehicle"),
                L("N448", "5012007     Carrying unauthorised passenger on goods vehicle"),
                L("N538", "5012008     Carrying Unauthorised Passenger on Goods Vehicle"),
                L("N449", "5012012     Using trailer for carrying passengers for hire or reward"),
                L("N450", "5012013     Excess weight"),
                L("N451", "5012015     Excess axle weight"),
                L("N452", "5012027     No PSV licence"),
                L("N453", "5012032     No vehicle test certificate"),
                L("N454", "5012047     Overcrowding on PSV"),
                L("N455", "5012051     Failing to wear taxi drivers' badge"),
                L("N456", "5012053     Exceeding driving periods"),
                L("N457", "5012054     Failing to operate switch mechanisms to tachograph"),
                L("N458", "5012055     Using record sheet for longer than stipulated"),
                L("N459", "5012057     Failing to return record sheet within 21 days"),
                L("N460", "5012061     Failing to keep tachograph record sheets in clean condition"),
                L("N461", "5012066     No taxi roof sign"),
                L("N462", "5012074     Failing to take daily rest period from driving"),
                L("N463", "5012085     Driver smoking in PSV"),
                L("N464", "5012086     Passenger smoking in PSV"),
                L("N465", "5012102     No goods vehicle test certificate"),
                L("N466", "5013004     Insecure load"),
                L("N467", "5013006     No speedometer"),
                L("N468", "5013007     Defective speedometer"),
                L("N469", "5013010     Unmarked tow rope"),
                L("N470", "5013013     No mirrors on motor vehicle"),
                L("N471", "5013016     Defective windscreen washers"),
                L("N472", "5013019     Dirty windscreen"),
                L("N025", "5013021     No Prescribed Braking System"),
                L("N026", "5013022     Defective Braking System"),
                L("N027", "5013025     Defective Steering"),
                L("N473", "5013028     No windscreen wipers"),
                L("N474", "5013029     Defective windscreen wipers"),
                L("N475", "5013032     Defective seatbelts"),
                L("N028", "5013036     Carrying child under 14 years without seat belt (front)"),
                L("N151", "5013037     Defective Exhaust & Silencer System"),
                L("N539", "5013040     Excessive Smoke"),
                L("N476", "5013042     Using strident horn on motor vehicle"),
                L("N477", "5013043     No horn"),
                L("N478", "5013045     Using vehicle fitted with two tone horn"),
                L("N479", "5013046     Using horn when stationary"),
                L("N029", "5013049     Defective Tyre General"),
                L("N480", "5013050     Defective tyres"),
                L("N030", "5013067     Driver unable to have proper control of vehicle"),
                L("N481", "5013068     No footrests on motorcycle"),
                L("N482", "5013074     Failing to switch off engine"),
                L("N031", "5013075     Failing to Set Handbrake"),
                L("N483", "5013078     Excess noise"),
                L("N153", "5013079     No passenger seat belt fitted"),
                L("N484", "5013081     No mudguards on trailer"),
                L("N485", "5013084     Failing to notify police of abnormal load"),
                L("N486", "5013085     No manufacturer's plate fitted"),
                L("N487", "5013089     No mudguards on motor car"),
                L("N488", "5013090     No mudguards on agricultural motor vehicle"),
                L("N032", "5013091     Tyres insufficient to support axle weight"),
                L("N489", "5013092     Unframed internal mirror"),
                L("N490", "5013093     No windscreen washers"),
                L("N491", "5013094     No driver's seat belt fitted"),
                L("N492", "5013095     No anchorage points"),
                L("N493", "5013096     Insure petrol tank"),
                L("N494", "5013097     Leaking petrol tank"),
                L("N495", "5013102     Use vehicle not fitted with suitable and sufficient springs"),
                L("N496", "5013104     Tampering with excess fuel device"),
                L("N497", "5013107     No mudguards on motorcycle"),
                L("N498", "5013108     No rear protective guard"),
                L("N499", "5013109     Defective rear protective guard"),
                L("N500", "5013110     No side protective guard"),
                L("N501", "5013111     Defective side protective guard"),
                L("N502", "5013114     Dangerous mascot on motor"),
                L("N033", "5013115     Carrying child under 14 years without seatbelt (rear)"),
                L("N154", "5013116     Opening vehicle door causing Danger"),
                L("N155", "5013117     Driver unable to have full view of road"),
                L("N503", "5013118     Reversing for unreasonable distance"),
                L("N504", "5013119     Failing to stop machinery when vehicle is stationary"),
                L("N505", "5013120     Sounding horn at night on restricted road"),
                L("N506", "5013121     Drawing more that permitted number of trailers"),
                L("N507", "5013122     Towing with rope in excess of prescribed limit"),
                L("N034", "5013126     Exceeding height limit of semi-trailer"),
                L("N508", "5013127     Trailer failing to have minimum ground clearance"),
                L("N509", "5013128     Vehicle exceeding permitted length"),
                L("N510", "5013129     Vehicle exceeding permitted width"),
                L("N511", "5013130     Vehicle exceeding permitted overhang"),
                L("N512", "5013133     No spray suppression device"),
                L("N513", "5013134     Failing to maintain spray suppression device"),
                L("N514", "5013135     Motorcycle sidecar not properly attached"),
                L("N515", "5013136     Carrying passengers in a living van"),
                L("N516", "5013137     Lifting apparatus not properly secured"),
                L("N517", "5013138     Television receiving apparatus in sight of driver"),
                L("N518", "5013140     Failing to wear seat belt passenger"),
                L("N045", "5013141     Driving passenger car with unrestrained child under 12 year"),
                L("N044", "5013156     Using a Vehicle in A Dangerous Condition"),
                L("N519", "5013172     Failing to maintain excess fuel device"),
                L("N520", "5013179     Failure to have obligatory lamp or reflector or rear marking"),
                L("N035", "013265     Using a Mobile Phone whilst Driving"),
                L("N186", "5013266     Using a vehicle with windows with insufficient transmission"),
                L("N036", "5013268     Failing to Wear Seat Belt Driver"),
                L("N037", "5013269     Driver Carrying Unbelted Child Under 14 Years"),
                L("N038", "5013271     Driver Carrying Child Under 12 Years without restrain"),
                L("N039", "5013272     Using a Hand-held Mobile Phone"),
                L("N040", "5013273     Driver does not have Proper Control of Vehicle"),
                L("N041", "5013274     Driver does not have Full View of Road and Traffic Ahead"),
                L("N521", "5014012     No lights on pedal cycle"),
                L("N522", "5014023     No lights on projecting load"),
                L("N523", "5014024     No side marker lamps on projecting load"),
                L("N524", "5014050     Fitting lamp capable of showing red light to front"),
                L("N525", "5014057     Failing to have warning beacon fitted"),
                L("N526", "5014058     Defective light"),
                L("N527", "5014064     Using vehicle when lamp not lit and unobscured"),
                L("N528", "5014065     Allow unlighted vehicle to remain at rest on a road"),
                L("N529", "5014068     Unlawful use of lamp"),
                L("N530", "5014069     Unlawful use of hazard warning signal device"),
                L("N531", "5014072     No school bus sign"),
                L("N532", "5015006     No number plate"),
                L("N533", "5015010     Obscured number plate"),
                L("N534", "5015011     Failing to display trade plates"),
                L("N535", "5015013     Incorrect form of registration mark"),
                L("E014", "E014     Accident Not Reported by the Insured RoI"),
                L("AC10", "AC10     Failing To Stop After an Accident"),
                L("AC12", "AC12     Aiding And Abetting AC10"),
                L("AC14", "AC14     Causing Or Permitting AC10"),
                L("AC16", "AC16     Inciting AC10"),
                L("AC20", "AC20     Failure To Report Within 24 Hours"),
                L("AC22", "AC22     Aiding And Abetting AC20"),
                L("AC24", "AC24     Causing Or Permitting AC20"),
                L("AC26", "AC26     Inciting AC20"),
                L("AC30", "AC30     Undefined Accident Offence"),
                L("AC32", "AC32     Aiding And Abetting AC30"),
                L("AC34", "AC34     Causing Or Permitting AC30"),
                L("AC36", "AC36     Inciting AC30"),
                L("Z011", "Z011     Ban From Driving In Any EU Country (Excluding The UK)"),
                L("BA10", "BA10     Driving While Disqualified by Order of Court"),
                L("BA12", "BA12     Aiding And Abetting BA10"),
                L("BA14", "BA14     Causing Or Permitting BA10"),
                L("BA16", "BA16     Inciting BA10"),
                L("BA30", "BA30     Attempting To Drive While Disqualified by Order of Court"),
                L("BA32", "BA32     Aiding And Abetting BA30"),
                L("BA34", "BA34     Causing Or Permitting BA30"),
                L("BA36", "BA36     Inciting BA30"),
                L("BA40", "BA40     Causing Death By Driving Whilst Disqualified"),
                L("BA42", "BA42     Aiding And Abetting BA40"),
                L("BA44", "BA44     Causing Or Permitting BA40"),
                L("BA46", "BA46     Inciting BA40"),
                L("BA60", "BA60     Causing Serious Injury By Driving While Disqualified"),
                L("BA62", "BA62     Aiding And Abetting BA60"),
                L("BA64", "BA64     Causing Or Permitting BA60"),
                L("BA66", "BA66     Inciting BA60"),
                L("NA01", "NA01     Causing GBI by dvg carelessly/inconsiderately whilst unfit NI"),
                L("NA02", "NA02     Causing GBI dvg carelessly with excess alcohol or drugs NI"),
                L("CD10", "CD10     Driving Without Due Care And Attention"),
                L("CD12", "CD12     Aiding And Abetting CD10"),
                L("CD14", "CD14     Causing Or Permitting CD10"),
                L("CD16", "CD16     Inciting CD10"),
                L("CD20", "CD20     Driving Without Reasonable Consideration For Other Road Users"),
                L("CD22", "CD22     Aiding And Abetting CD20"),
                L("CD24", "CD24     Causing Or Permitting CD20"),
                L("CD26", "CD26     Inciting CD20"),
                L("CD30", "CD30     Driving Without Due Care Or Reasonable Consideration"),
                L("CD32", "CD32     Aiding And Abetting CD30"),
                L("CD34", "CD34     Causing Or Permitting CD30"),
                L("CD36", "CD36     Inciting CD30"),
                L("CD40", "CD40     Causing Death By Careless Driving When Unfit Through Drink"),
                L("CD42", "CD42     Aiding And Abetting CD40"),
                L("CD44", "CD44     Causing Or Permitting CD40"),
                L("CD46", "CD46     Inciting CD40"),
                L("CD50", "CD50     Causing Death By Careless Driving When Unfit Through Drugs"),
                L("CD52", "CD52     Aiding And Abetting CD50"),
                L("CD54", "CD54     Causing Or Permitting CD50"),
                L("CD56", "CD56     Inciting CD50"),
                L("CD60", "CD60     Causing Death By Careless Driving With Above Limit Alcohol"),
                L("CD62", "CD62     Aiding And Abetting CD60"),
                L("CD64", "CD64     Causing Or Permitting CD60"),
                L("CD66", "CD66     Inciting CD60"),
                L("CD70", "CD70     Cause Death By Careless Driving and Not Supply A Specimen"),
                L("CD72", "CD72     Aiding And Abetting CD70"),
                L("CD74", "CD74     Causing Or Permitting CD70"),
                L("CD76", "CD76     Inciting CD70"),
                L("CD80", "CD80     Causing Death By Careless Or Inconsiderate Driving"),
                L("CD82", "CD82     Aiding And Abetting CD80"),
                L("CD84", "CD84     Causing Or Permitting CD80"),
                L("CD86", "CD86     Inciting CD80"),
                L("CD90", "CD90     Causing Death By Driving Unlicensed, Uninsured Or Disqualified"),
                L("CD92", "CD92     Aiding And Abetting CD90"),
                L("CD94", "CD94     Causing Or Permitting CD90"),
                L("CD96", "CD96     Inciting CD90"),
                L("CU10", "CU10     Using a Vehicle With Defective Brakes"),
                L("CU12", "CU12     Aiding And Abetting CU10"),
                L("CU14", "CU14     Causing Or Permitting CU10"),
                L("CU16", "CU16     Inciting CU10"),
                L("CU20", "CU20     Dangerous vehicle condition (Excl Brakes, Steering Or Tyres)"),
                L("CU22", "CU22     Aiding And Abetting CU20"),
                L("CU24", "CU24     Causing Or Permitting CU20"),
                L("CU26", "CU26     Inciting CU20"),
                L("CU30", "CU30     Using a Vehicle With Defective Tyre(s)"),
                L("CU32", "CU32     Aiding And Abetting CU30"),
                L("CU34", "CU34     Causing Or Permitting CU30"),
                L("CU36", "CU36     Inciting CU30"),
                L("CU40", "CU40     Using a Vehicle With Defective Steering"),
                L("CU42", "CU42     Aiding And Abetting CU40"),
                L("CU44", "CU44     Causing Or Permitting CU40"),
                L("CU46", "CU46     Inciting CU40"),
                L("CU50", "CU50     Dangerous Load or Passengers"),
                L("CU52", "CU52     Aiding And Abetting CU50"),
                L("CU54", "CU54     Causing Or Permitting CU50"),
                L("CU56", "CU56     Inciting CU50"),
                L("CU80", "CU80     Breach of vehicle control eg Mobile Phone"),
                L("CU82", "CU82     Aiding And Abetting CU80"),
                L("CU84", "CU84     Causing Or Permitting CU80"),
                L("CU86", "CU86     Inciting CU80"),
                L("E008", "E008     Dangerous Driving RoI"),
                L("DD10", "DD10     Causing Serious Injury by Dangerous Driving"),
                L("DD12", "DD12     Aiding And Abetting DD10"),
                L("DD14", "DD14     Causing Or Permitting DD10"),
                L("DD16", "DD16     Inciting DD10"),
                L("DD40", "DD40     Dangerous Driving"),
                L("DD42", "DD42     Aiding And Abetting DD40"),
                L("DD44", "DD44     Causing Or Permitting DD40"),
                L("DD46", "DD46     Inciting DD40"),
                L("DD60", "DD60     Manslaughter Or Culpable Homicide While Driving a Vehicle"),
                L("DD62", "DD62     Aiding And Abetting DD60"),
                L("DD64", "DD64     Causing Or Permitting DD60"),
                L("DD66", "DD66     Inciting DD60"),
                L("DD80", "DD80     Causing Death By Dangerous Driving"),
                L("DD82", "DD82     Aiding And Abetting DD80"),
                L("DD84", "DD84     Causing Or Permitting DD80"),
                L("DD86", "DD86     Inciting DD80"),
                L("DD90", "DD90     Furious Driving"),
                L("DD92", "DD92     Aiding And Abetting DD90"),
                L("DD94", "DD94     Causing Or Permitting DD90"),
                L("DD96", "DD96     Inciting DD90"),
                L("DG10", "DG10     Driving Or Attempting To Drive With Drug Level Above Specified"),
                L("DG12", "DG12     Aiding And Abetting DG10"),
                L("DG14", "DG14     Causing Or Permitting DG10"),
                L("DG16", "DG16     Inciting DG10"),
                L("DG40", "DG40     In Charge Of A Vehicle While Drug Level Above Specified Limit"),
                L("DG42", "DG42     Aiding And Abetting DG40"),
                L("DG44", "DG44     Causing Or Permitting DG40"),
                L("DG46", "DG46     Inciting DG40"),
                L("DG60", "DG60     Causing Death By Careless Driving With Drug Level Above The Lim"),
                L("DG62", "DG62     Aiding And Abetting DG60"),
                L("DG64", "DG64     Causing Or Permitting DG60"),
                L("DG66", "DG66     Inciting DG60"),
                L("E009", "E009     Driving of Dangerously Defective Vehicle RoI"),
                L("E003", "E003     Driving While Unfit by Virtue of Disease or Physical/Mental Disability"),
                L("E007", "E007     Driving Without Due Care and Attention (Careless Driving) RoI"),
                L("E011", "E011     Driving Without Insurance RoI"),
                L("E006", "E006     Driving Without Reasonable Consideration RoI"),
                L("E004", "E004     Drunk Driving RoI"),
                L("E005", "E005     Drunk in Charge RoI"),
                L("DR10", "DR10     Driving Or Attempting to Drive With Alcohol Level Above Limit"),
                L("DR12", "DR12     Aiding And Abetting DR10"),
                L("DR14", "DR14     Causing Or Permitting DR10"),
                L("DR16", "DR16     Inciting DR10"),
                L("DR20", "DR20     Driving Or Attempting to Drive While Unfit Through Drink"),
                L("DR22", "DR22     Aiding And Abetting DR20"),
                L("DR24", "DR24     Causing Or Permitting DR20"),
                L("DR26", "DR26     Inciting DR20"),
                L("DR30", "DR30     Failure to supply specimen whilst driving/attempting to drive"),
                L("DR32", "DR32     Aiding And Abetting DR30"),
                L("DR34", "DR34     Causing Or Permitting DR30"),
                L("DR36", "DR36     Inciting DR30"),
                L("DR40", "DR40     In Charge Of a Vehicle While Alcohol Level Above Limit"),
                L("DR42", "DR42     Aiding And Abetting DR40"),
                L("DR44", "DR44     Causing Or Permitting DR40"),
                L("DR46", "DR46     IncitingDR40"),
                L("DR50", "DR50     In Charge Of a Vehicle While Unfit Through Drink"),
                L("DR52", "DR52     Aiding And Abetting DR50"),
                L("DR54", "DR54     Causing Or Permitting DR50"),
                L("DR56", "DR56     Inciting DR50"),
                L("DR60", "DR60     Failure to provide specimen other than according to DR30"),
                L("DR62", "DR62     Aiding And Abetting DR60"),
                L("DR64", "DR64     Causing Or Permitting DR60"),
                L("DR66", "DR66     Inciting DR60"),
                L("DR70", "DR70     Failing To Provide Specimen For Breath Test"),
                L("DR72", "DR72     Aiding And Abetting DR70"),
                L("DR74", "DR74     Causing Or Permitting DR70"),
                L("DR76", "DR76     Inciting DR70"),
                L("DR80", "DR80     Driving Or Attempting To Drive When Unfit Through Drugs"),
                L("DR82", "DR82     Aiding And Abetting DR80"),
                L("DR84", "DR84     Causing Or Inciting DR80"),
                L("DR86", "DR86     Inciting DR80"),
                L("DR90", "DR90     In Charge Of A Vehicle When Unfit Through Drugs"),
                L("DR92", "DR92     Aiding And Abetting DR90"),
                L("DR94", "DR94     Causing Or Permitting DR90"),
                L("DR96", "DR96     Inciting DR90"),
                L("E017", "E017     Duties on Occurrence of Accident Failure to Comply (Hit and Run) R"),
                L("E002", "E002     Exceeding Speed Limit RoI"),
                L("E013", "E013     Failure to Produce RTA Certificate RoI"),
                L("E012", "E012     Fraud in Obtaining Insurance RoI"),
                L("QI09", "QI09     GB drivers disqualified in Isle of Man"),
                L("NI09", "NI09     GB drivers disqualified in Northern Ireland"),
                L("NR09", "NR09     GB drivers revoked under the New Drivers Act in Northern Ireland"),
                L("IN10", "IN10     Using a Vehicle Uninsured Against Third Party Risks"),
                L("IN12", "IN12     Aiding And Abetting IN10"),
                L("IN14", "IN14     Causing Or Permitting IN10"),
                L("IN16", "IN16     Inciting IN10"),
                L("LC20", "LC20     Driving otherwise than in accordance with a licence"),
                L("LC22", "LC22     Aiding Abetting LC20"),
                L("LC24", "LC24     Causing Permitting - LC20"),
                L("LC26", "LC26     Inciting LC20"),
                L("LC30", "LC30     Driving After False Decl Re Fitness When Licence Applied For"),
                L("LC32", "LC32     Aiding And Abetting LC30"),
                L("LC34", "LC34     Causing Or Permitting LC30"),
                L("LC36", "LC36     Inciting LC30"),
                L("LC40", "LC40     Driving A Vehicle Having Failed To Notify A Disability"),
                L("LC42", "LC42     Aiding And Abetting LC40"),
                L("LC44", "LC44     Causing Or Permitting LC40"),
                L("LC46", "LC46     Inciting LC40"),
                L("LC50", "LC50     Driving After A Licence Revoked Or Refused On Medical Grounds"),
                L("LC52", "LC52     Aiding And Abetting LC50"),
                L("LC54", "LC54     Causing Or Permitting LC50"),
                L("LC56", "LC56     Inciting LC50"),
                L("MR09", "MR09     Reckless Or Dangerous Driving"),
                L("MR19", "MR19     Wilful Failure to Stop and Report Following a Road Accident"),
                L("MR29", "MR29     Driving Vehicle Under the Influence Affecting Driver Abilities"),
                L("MR39", "MR39     Driving a Vehicle Faster Than the Permitted Speed"),
                L("MR49", "MR49     Driving a Vehicle Whilst Disqualified"),
                L("MR59", "MR59     Other Driving Disqualification Offence"),
                L("MS10", "MS10     Leaving Vehicle In Dangerous Position"),
                L("MS12", "MS12     Aiding And Abetting MS10"),
                L("MS14", "MS14     Causing Or Permitting MS10"),
                L("MS16", "MS16     Inciting MS10"),
                L("MS20", "MS20     Unlawful Pillion Riding"),
                L("MS22", "MS22     Aiding And Abetting MS20"),
                L("MS24", "MS24     Causing Or Permitting MS20"),
                L("MS26", "MS26     Inciting MS20"),
                L("MS30", "MS30     Play Street Offences"),
                L("MS32", "MS32     Aiding And Abetting MS30"),
                L("MS34", "MS34     Causing Or Permitting MS30"),
                L("MS36", "MS36     Inciting MS30"),
                L("MS50", "MS50     Motor Racing On Highway"),
                L("MS52", "MS52     Aiding And Abetting MS50"),
                L("MS54", "MS54     Causing Or Permitting MS50"),
                L("MS56", "MS56     Inciting MS50"),
                L("MS60", "MS60     Offence Not Covered By Other Codes"),
                L("MS62", "MS62     Aiding And Abetting MS60"),
                L("MS64", "MS64     Causing Or Permitting MS60"),
                L("MS66", "MS66     Inciting MS60"),
                L("MS70", "MS70     Driving With Uncorrected Defective Eyesight"),
                L("MS72", "MS72     Aiding And Abetting MS70"),
                L("MS74", "MS74     Causing Or Permitting MS70"),
                L("MS76", "MS76     Inciting MS70"),
                L("MS80", "MS80     Refusing To Submit To An Eyesight Test"),
                L("MS82", "MS82     Aiding And Abetting MS80"),
                L("MS84", "MS84     Causing Or Permitting MS80"),
                L("MS86", "MS86     Inciting MS80"),
                L("MS90", "MS90     Failure To Give Information As To Identity Of Driver Etc"),
                L("MS92", "MS92     Aiding And Abetting MS90"),
                L("MS94", "MS94     Causing Or Permitting MS90"),
                L("MS96", "MS96     Inciting MS90"),
                L("MW10", "MW10     Contravening Special Road Regulations (Excl Speed)"),
                L("MW12", "MW12     Aiding And Abetting MW10"),
                L("MW14", "MW14     Causing Or Permitting MW10"),
                L("MW16", "MW16     Inciting MW10"),
                L("NEND", "NEND     Non Endorsable Offence"),
                L("E001", "E001     No Driving Licence Driving While Disqualified RoI"),
                L("Z001", "Z001     Non-Road Traffic Act Fraud"),
                L("Z004", "Z004     Non-Road Traffic Act Handling Stolen Goods"),
                L("Z002", "Z002     Non-Road Traffic Act Robbery"),
                L("Z003", "Z003     Non-Road Traffic Act Theft"),
                L("Z999", "Z999     Not Otherwise Listed"),
                L("Z006", "Z006     Parking Offence"),
                L("E016", "E016     Parking Offence RoI"),
                L("E010", "E010     Parking Vehicle in Dangerous Position RoI"),
                L("PC10", "PC10     Undefined Contravention of Pedestrian Crossing Regulations"),
                L("PC12", "PC12     Aiding And Abetting PC10"),
                L("PC14", "PC14     Causing Or Permitting PC10"),
                L("PC16", "PC16     Inciting PC10"),
                L("PC20", "PC20     Pedestrian crossing contravention with moving vehicle"),
                L("PC22", "PC22     Aiding And Abetting PC20"),
                L("PC24", "PC24     Causing Or Permitting PC20"),
                L("PC26", "PC26     Inciting     PC20"),
                L("PC30", "PC30     Pedestrian crossing contravention with stationary vehicle"),
                L("PC32", "PC32     Aiding And Abetting PC30"),
                L("PC34", "PC34     Causing Or Permitting PC30"),
                L("PC36", "PC36     Inciting PC30"),
                L("Z005", "Z005     Prosecution Pending"),
                L("E015", "E015     Sign/Signal not Observed RoI"),
                L("SP10", "SP10     Exceeding Goods Vehicle Speed Limits"),
                L("SP12", "SP12     Aiding And Abetting SP10"),
                L("SP14", "SP14     Causing Or Permitting SP10"),
                L("SP16", "SP16     Inciting SP10"),
                L("SP20", "SP20     Speeding (Excl Goods Or Passenger Vehicles)"),
                L("SP22", "SP22     Aiding And Abetting SP20"),
                L("SP24", "SP24     Causing Or Permitting SP20"),
                L("SP26", "SP26     Inciting SP20"),
                L("SP30", "SP30     Exceeding Statutory Speed Limit On a Public Road"),
                L("SP32", "SP32     Aiding And Abetting SP30"),
                L("SP34", "SP34     Causing Or Permitting SP30"),
                L("SP36", "SP36     Inciting SP30"),
                L("SP40", "SP40     Exceeding Passenger Vehicle Speed Limit"),
                L("SP42", "SP42     Aiding And Abetting SP40"),
                L("SP44", "SP44     Causing Or Permitting SP40"),
                L("SP46", "SP46     Inciting SP40"),
                L("SP50", "SP50     Exceeding Speed Limit On a Motorway"),
                L("SP52", "SP52     Aiding And Abetting SP50"),
                L("SP54", "SP54     Causing Or Permitting SP50"),
                L("SP56", "SP56     Inciting SP50"),
                L("Z010", "Z010     Tachograph Offence"),
                L("TS10", "TS10     Failing To Comply With Traffic Light Signals"),
                L("TS12", "TS12     Aiding And Abetting TS10"),
                L("TS14", "TS14     Causing Or Permitting TS10"),
                L("TS16", "TS16     Inciting TS10"),
                L("TS20", "TS20     Failing To Comply With Double White Lines"),
                L("TS22", "TS22     Aiding And Abetting TS20"),
                L("TS24", "TS24     Causing Or Permitting TS20"),
                L("TS26", "TS26     Inciting TS20"),
                L("TS30", "TS30     Failing To Comply With Stop Sign"),
                L("TS32", "TS32     Aiding And Abetting TS30"),
                L("TS34", "TS34     Causing Or Permitting TS30"),
                L("TS36", "TS36     Inciting TS30"),
                L("TS40", "TS40     Failing To Comply With Direction Of a Constable/Warden"),
                L("TS42", "TS42     Aiding And Abetting TS40"),
                L("TS44", "TS44     Causing Or Permitting TS40"),
                L("TS46", "TS46     Inciting TS40"),
                L("TS50", "TS50     Traffic Signs Offence (Ex Lights, Stop Or Double White Line)"),
                L("TS52", "TS52     Aiding And Abetting TS50"),
                L("TS54", "TS54     Causing Or Permitting TS50"),
                L("TS56", "TS56     Inciting TS50"),
                L("TS60", "TS60     Failing To Comply With a School Crossing Patrol Sign"),
                L("TS62", "TS62     Aiding And Abetting TS60"),
                L("TS64", "TS64     Causing Or Permitting TS60"),
                L("TS66", "TS66     Inciting TS60"),
                L("TS70", "TS70     Undefined Failure To Comply With a Traffic Direction Sign"),
                L("TS72", "TS72     Aiding And Abetting TS70"),
                L("TS74", "TS74     Causing Or Permitting TS70"),
                L("TS76", "TS76     Inciting TS70"),
                L("TT99", "TT99     Disqualified under totting up procedure"),
                L("E018", "E018     Unauthorised Taking of Vehicle RoI"),
                L("UT50", "UT50     Aggravated Taking Of A Vehicle"),
                L("UT52", "UT52     Aiding And Abetting UT50"),
                L("UT54", "UT54     Causing Or Permitting UT50"),
                L("UT56", "UT56     Inciting UT50"),
                L("NA03", "NA03     Wrongful use of a disabled drivers badge NI")
            ],
            industryGroup: [
                L("1", "Office and Emergency Services"),
                L("2", "Retired"),
                L("3", "Care Worker/Social Services"),
                L("4", "Teaching and Leisure"),
                L("5", "Other Office"),
                L("6", "Forces and Factory"),
                L("7", "Manual Unskilled"),
                L("8", "Other Profession"),
                L("9", "Finance"),
                L("10", "Retail and at Housespouse"),
                L("11", "Student"),
                L("12", "Medical")
            ],
            monthlyPaymentDates: [
                L("1", "1st"),
                L("2", "2nd"),
                L("3", "3rd"),
                L("4", "4th"),
                L("5", "5th"),
                L("6", "6th"),
                L("7", "7th"),
                L("8", "8th"),
                L("9", "9th"),
                L("10", "10th"),
                L("11", "11th"),
                L("12", "12th"),
                L("13", "13th"),
                L("14", "14th"),
                L("15", "15th"),
                L("16", "16th"),
                L("17", "17th"),
                L("18", "18th"),
                L("19", "19th"),
                L("20", "20th"),
                L("21", "21st"),
                L("22", "22nd"),
                L("23", "23rd"),
                L("24", "24th"),
                L("25", "25th"),
                L("26", "26th"),
                L("27", "27th"),
                L("28", "28th")
            ]
        };
    }
    FalconLookupService.prototype.fetchLookupValues = function (lookupName, languageCode, fieldValue) {
        var _this = this;
        if (lookupName.startsWith("all")) {
            var product = lookupName.slice(3); // trim "all" portion of the classifier
            // ignore fetch all motor call when classifiers are already fetched
            if (lookupName === "all".concat(product) && window.sessionStorage.getItem("".concat(product, "_classifier_all_loaded"))) {
                return (0, rxjs_1.of)([]);
            }
            return this.fetchAllProductClassifiers(lookupName, product);
        }
        else {
            return new rxjs_1.Observable(function (observer) {
                var lookupKey = lookupName;
                if (fieldValue !== undefined) {
                    lookupKey = lookupKey + '_' + fieldValue;
                }
                // try load classifier from local variable
                var lookup = _this.lookups[lookupKey];
                if (lookup) {
                    observer.next(lookup);
                    observer.complete();
                    return;
                }
                // try load classifier from session storage
                lookup = JSON.parse(window.sessionStorage.getItem("classifier_".concat(lookupKey)));
                if (lookup) {
                    _this.lookups[lookupKey] = lookup;
                    observer.next(lookup);
                    observer.complete();
                    return;
                }
                // load classifier from back-end and put in cache (local variable and session storage)
                _this.falconConvenienceApiService.getClassifiers(lookupName, fieldValue !== undefined ? fieldValue.toString() : undefined).toPromise()
                    .then(function (output) {
                    lookup = [];
                    var classifierNameToValues = new Map(Object.entries(output));
                    // put classifier in local variable
                    classifierNameToValues.forEach(function (classifierValues, classifierName) {
                        classifierValues.forEach(function (value) {
                            lookup.push(L(value.id, value.name));
                        });
                    });
                    _this.lookups[lookupKey] = lookup;
                    // put classifier in session storage
                    window.sessionStorage.setItem("classifier_".concat(lookupKey), JSON.stringify(lookup));
                    observer.next(lookup);
                    observer.complete();
                });
            });
        }
    };
    FalconLookupService.prototype.fetchAllProductClassifiers = function (classifier, product) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.falconConvenienceApiService.getAllProductClassifiers(product).toPromise()
                .then(function (output) {
                var classifierNameToValues = new Map(Object.entries(output));
                classifierNameToValues.forEach(function (classifierValues, classifierName) {
                    var lookup = [];
                    classifierValues.forEach(function (value) {
                        lookup.push(L(value.id, value.name));
                    });
                    _this.lookups[classifierName] = lookup;
                    window.sessionStorage.setItem("classifier_".concat(classifierName), JSON.stringify(lookup));
                });
                window.sessionStorage.setItem("".concat(product, "_classifier_all_loaded"), "true");
                observer.next([]);
                observer.complete();
            });
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], FalconLookupService.prototype, "falconConvenienceApiService", void 0);
    FalconLookupService = __decorate([
        (0, core_1.injectable)()
    ], FalconLookupService);
    return FalconLookupService;
}());
//# sourceMappingURL=FalconLookupService.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/FalconLookupService.js
// module id = 2481
// module chunks = 0